{
  "101": {
    "need_upgrade": "Need Upgrade",
    "it_seems_like_you_need_to_update": "It seems like you need to update your status in order to access this page",
    "go_back": "Go back",
    "report": "Report"
  },
  "404": {
    "404": "404",
    "it_seems_like_we_ran_into_trouble": "It seems like we ran into trouble loading this page",
    "go_back": "Go back",
    "report": "Report"
  },
  "access-person": {
    "download_the_document_list": "Download The Document List",
    "download_all_files": "Download All Files",
    "download_document": "Download Document",
    "file_name": "File Name",
    "uploaded": "Uploaded",
    "time_of_upload": "Time of Upload"
  },
  "add-new-transaction": {
    "name": "Name",
    "email": "E-mail",
    "position": "Position",
    "phone_number": "Phone Number",
    "this_form_is_required_for_disclosure": "This form is required for disclosure of transactions under Article 19 of Regulation (EU) No 596/2014 of the European Parliament and of the Council of 16 April 2014 on market abuse (Market Abuse Regulation)",
    "details_of_the_person_discharging": "1. Details of the person discharging managerial responsibilities/person closely associated",
    "natural_person": "Natural Person",
    "first_name": "First Name",
    "last_name": "Last Name",
    "legal_person": "Legal Person",
    "company_name": "Company Name",
    "full_name": "Full Name",
    "modify": "Modify",
    "reason_for_the_notification": "2. Reason for the notification",
    "position_status": "Position/Status",
    "initial_notification": "Initial Notification",
    "amendment_to_prior_notification": "Amendment to Prior Notifications",
    "description": "Description",
    "details_of_the_issuer": "3. Details of the issuer, emission allowance market participant, auction platform, auctioneer or auction monitor",
    "full_name_of_the_entity": "FUll Name of the Entity",
    "lei_legal_entity_identifier": "LEI / Legal Entity Identifier",
    "details_of_the_transaction": "4. Details of the transaction(s): section to be repeated for (i) each type of instrument; (ii) each type of transaction; (iii) each date; and (iv) each place where transactions have been conducted",
    "details_of_the_transaction_section": "4.{idx}. Details of the transaction(s): section to be repeated for (i) each type of instrument; (ii) each type of transaction; (iii) each date; and (iv) each place where transactions have been conducted",
    "description_of_the_financial_instrument": "Description of the financial instrument, type of instrument",
    "description_of_the_financial_instrument_placeholder": "Indication of the nature of the asset: (i) share, debt securities, derivative products or financial instruments related to shares or debt securities; (ii) emission allowance, emission allowance-based auction product or emission allowance-related derivative product.",
    "identification_code": "Identification Code",
    "identification_code_placeholder": "Identification Code",
    "nature_of_the_transaction": "Nature of the transaction",
    "description_of_the_transaction": "Description of the transaction type using, where applicable, the type of transaction identified in Article 10 of the Commission Delegated Regulation (EU) 2016/5221 adopted under Article 19(14) of Regulation (EU) No 596/2014 or a specific example set out in Article 19(7) of Regulation (EU) No 596/2014. Pursuant to Article 19(6)(e) of Regulation (EU) No 596/2014, it shall be indicated whether the transaction is linked to the exercise of a share option programme.",
    "prices_and_volumes": "Price(s) and Volume(s)",
    "aggregated_volume_and_price": "Aggregated Volume & Price",
    "time_of_the_transaction": "Date of the Transaction",
    "transaction_date_and_time": "Transaction Date & Time",
    "place_of_the_transaction": "Place of The Transaction",
    "name_and_code_to_identify_the_mifid": "Name and code to identify the MiFID trading venue, the systematic internaliser or the organised trading platform outside of the Union where the transaction was executed as defined under Commission Delegated Regulation supplementing Regulation (EU) No 600/2014 of the European Parliament and of the Council with regard to regulatory technical standards for the reporting of transactions to competent authorities adopted under Article 26 of Regulation (EU) No 600/2014, or if the transaction was not executed on any of the above mentioned venues, please mention 'outside a trading venue'.",
    "additional_information": "Additional Information",
    "submit_form": "Submit Form",
    "where_more_then_one_transaction": "Where more than one transaction of the same nature (purchases, sales, lendings, borrows, …) on the same financial instrument or emission allowance are executed on the same day and on the same place of transaction, prices and volumes of these transactions shall be reported in this field, in a two columns form as presented above, inserting as many lines as needed.",
    "new_detail": "Add new detail",
    "remove_detail": "Remove detail",
    "position_status_pdmr_placeholder": "In the case of a person performing managerial duties: the position held within the issuer, emission units market participant/auction platform/auctioneer/auction controller must be specified (e.g. CEO, CFO, etc.)",
    "position_status_pca_placeholder": "In the case of a person closely related to a person performing managerial duties: — it must be stated that the notification concerns a person closely related to a person performing managerial duties; — the name and position of the relevant person performing managerial duties",
    "pdmr_title": "person performing managerial duties",
    "pca_title": "person closely associated with a person performing managerial duties",
    "please_fill_in_all_prices_and_volumes": "Please fill in all prices and volumes"
  },
  "advisory": {
    "companies_title": "Advisory companies",
    "lists_title": "Advisory insider lists",
    "list_details": "Advisory list",
    "company_name": "Company name",
    "add_company": "Add company",
    "edit_company": "Edit company",
    "save": "Save",
    "cancel": "Cancel",
    "create_list": "Create list",
    "list_name": "List name",
    "list_name_required": "Please enter a list name.",
    "edit_list_name": "Edit list name",
    "insiders_tab": "Insiders",
    "company": "Company",
    "select_company": "Select company",
    "active_lists": "Active lists",
    "closed_lists": "Closed lists",
    "details": "Details",
    "export": "Export",
    "export_list": "Export list",
    "select_version": "Version",
    "download": "Download",
    "add_person": "Add person",
    "search": "Search",
    "address": "Address",
    "registration_number": "Registration number",
    "tax_number": "Tax number",
    "lei_number": "LEI",
    "data_protection_officer": "Data protection officer",
    "contact_address": "Contact address",
    "website": "Website",
    "email": "Email",
    "phone_number": "Phone",
    "city": "City",
    "zip_code": "ZIP code",
    "date_of_creation": "Date of creation",
    "last_update": "Last update",
    "no_companies": "No companies yet.",
    "no_lists": "No lists yet.",
    "control_panel_title": "Advisory lists",
    "advisory_lists_section": "Advisory insider lists",
    "cease_list": "Cease list",
    "cease_list_modal_title": "Cease advisory list",
    "cease_date_label": "Cease date and time",
    "cease_list_confirm": "Cease list",
    "cease_date_required": "Please select a cease date.",
    "bulk_add_modal_title": "Add multiple people to this advisory list",
    "back_to_single_add": "Add one person",
    "bulk_notification_tooltip": "When enabled, this person will be included in the next step where you can send the advisory list inclusion notification email after users are added.",
    "advisory_first_name_required": "First name is required.",
    "advisory_last_name_required": "Last name is required.",
    "advisory_phone_required": "Phone number is required.",
    "advisory_phone_format": "The phone number must be in the format +36221234567 (+ followed by exactly 11 digits).",
    "advisory_phone_placeholder": "+36221234567",
    "function_and_reason": "Function and reason",
    "central_contact": "Central contact",
    "send_notification": "Send notification",
    "advisory_email_required": "Email is required.",
    "advisory_email_chars": "The email may only contain letters, numbers, and the characters {'@'} . _ + - .",
    "advisory_name_max": "This field may not be greater than 255 characters.",
    "advisory_function_reason_max": "This field may not be greater than 5000 characters.",
    "advisory_date_of_listing_required": "Please select the date of listing.",
    "col_inclusion_email_sent": "Inclusion email",
    "resend_notification": "Resend notification email",
    "col_statement_signed": "Statement signed",
    "personal_address_field": "Personal address"
  },
  "billing-data": {
    "name": "Name",
    "zip_code": "Zip Code",
    "city": "City",
    "address": "Address",
    "tax_number": "Tax Number",
    "save": "Save",
    "billing_title": "Change your billing Data",
    "billing_subtitle": "Enter your billing details",
    "invoices": "Invoices",
    "contracts": "Contracts",
    "subscriptions": "Subscriptions",
    "view_client": "View Client",
    "billing": "Billing",
    "create_billingo_partner": "Create Billingo Partner",
    "new_invoice": "New Invoice",
    "client": "Client",
    "invoice_number": "Invoice Number",
    "download_invoice": "Download Invoice",
    "package": "Package",
    "period": "Period",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "discard": "Discard",
    "date": "Date",
    "new_contract": "New Contract",
    "save_new_invoice": "Save New Invoice",
    "contract_name": "Contract Name",
    "contract_date": "Contract Date",
    "select_contract": "Select Contract",
    "download_contract": "Download Contract",
    "end_date": "End Date",
    "new_subscription": "New Subscription",
    "start_date": "Start Date",
    "finalize_subscription": "Finalize Subscription",
    "edit": "Edit",
    "cancel": "Cancel",
    "permanent_delete": "Permanent deletion",
    "permanent_delete_description": "I am permanently and irrevocably deleting the following customer:",
    "permanent_delete_sub_description": "To confirm, please copy the customer's name into the input field."
  },
  "charts": {
    "no_data_available": "No data available",
    "insider_list_information": "Insider List Information",
    "insider_list_statements": "Insider List Statements",
    "insider_list_count": "Number of Insider Lists",
    "insider_list_user_count": "Number of Insiders",
    "market_sounding": "Market sounding",
    "below_33": "Below 33%",
    "between_33_66": "Between 33% and 66%",
    "above_66": "Above 66%",
    "filled": "Filled",
    "not_filled": "Not filled",
    "chart_insider_list_completion_rate": "Insider List Completion Rate",
    "chart_insider_list_acknowledgements": "Insider List Acknowledgements",
    "chart_number_of_insider_lists": "Number of Insider Lists",
    "chart_number_of_insiders": "Number of Insiders",
    "chart_pdmr_completion_rate": "PDMR Completion Rate",
    "chart_pca_completion_rate": "PCA Completion Rate",
    "chart_number_of_pdmrs": "Number of PDMRs",
    "chart_number_of_pcas": "Number of PCAs",
    "chart_market_sounding_acknowledgements": "Market Sounding Acknowledgements"
  },
  "classification-info": {
    "qualification_and_delay_of_inside_information": "Inside Information",
    "add_new_information": "Add New Information",
    "current_inside_information": "Current Inside Information",
    "previous_inside_information": "Previous Inside Information",
    "sensitive_information": "Sensitive Information",
    "search": "Search",
    "delay_occurred": "Delay occurred",
    "delay": "Delay",
    "intermediate_step": "Intermediate step",
    "intermediate_step_question": "Is the information to be assessed considered an intermediate step in a protracted process under MAR?",
    "make_public": "Disclose",
    "delete": "Delete",
    "do_you_want_to_cease": "Are you sure you want to delete this information permanently? By deleting this information, the relevant list will also be permanently deleted.",
    "back": "Back",
    "cease": "Cease",
    "edit": "Edit",
    "disable": "Disable",
    "short_name": "Project Name",
    "date_identified": "Date When Identified",
    "date_of_delay": "Date of Delay",
    "delay_occured": "Delay occured",
    "ceased": "Ceased",
    "statement_is": "Statement is",
    "fulfilled": "fulfilled",
    "not_fulfilled": "not fulfilled",
    "reason_for_delay": "Reason for Delay",
    "reclassify_the_information": "Reclassify The Information",
    "reclassify": "Reclassify",
    "requalification_of_information": "Qualification of New Information",
    "project_name": "Project Name",
    "please_indicate_the_name_of_the_project": "Please indicate the name of the project (e.g. merger, project MABU, etc.). It is important that this field cannot contain any inside information.",
    "description_of_the_information": "Description of the Information to be Qualified",
    "current_date_and_time": "Date of Qualification",
    "delay_date": "Date of delay",
    "uploaded_files": "Uploaded Files",
    "upload_file": "Upload File",
    "attention_the_insider_information_is_being_created": "Attention! This inside information is being created, please do not close the window, or proceed anywhere!",
    "attention_the_selected_files_are_uploading": "Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
    "discard": "Discard",
    "classify_information": "Classify The Information",
    "what_do_you_want_to_do_with_the_information": "What do you want to do with the information?",
    "immediate_publication": "Immediate Publication",
    "this_information_does_not_qualify": "This information does not qualify as inside information. Do you want to create a confidential list?",
    "no": "No",
    "yes": "Yes",
    "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
    "ok": "Ok",
    "files_uploaded_successfully": "Files uploaded successfully!",
    "successfully_created": "Successfully created!",
    "edit_the_information": "Edit the information",
    "confirm_edit_the_information": "Confirm Edit the information",
    "do_you_want_to_Reclassify_the_information": "Do you want to Reclassify the information",
    "save_changes": "Save Changes",
    "download": "Download",
    "conceptual_elements_of_inside_information": "Conceptual Elements of Inside Information",
    "add_comment": "Add Comment",
    "choose": "Choose",
    "download_file": "Download File",
    "please_provide_information": "Please provide information on the disclosure of inside information.",
    "link": "Link",
    "k_number": "K-Number",
    "date_and_time_of_publication": "Date and time of publication",
    "approve": "Approve",
    "reclassification_of_information": "Reclassification of information",
    "date_of_qualification": "Date of Qualification",
    "do_you_want_to_delete_the_insider_information": "Do you want to delete the inside information?",
    "create_confidential_list": "Create Confidential List",
    "confirm": "Confirm",
    "qualification_step_1_title": "Is the information of a precise nature?",
    "qualification_step_1_description": "Information shall be deemed to be of a precise nature if it indicates a set of circumstances which exists or which may reasonably be expected to come into existence, or an event which has occurred or which may reasonably be expected to occur, where it is specific enough to enable a conclusion to be drawn as to the possible effect of that set of circumstances or event on the prices of the financial instruments or the related derivative financial instrument, the related spot commodity contracts, or the auctioned products based on the emission allowances.<br>\nIn this respect in the case of a protracted process that is intended to bring about, or that results in, particular circumstances or a particular event, those future circumstances or that future event, and also the intermediate steps of that process which are connected with bringing about or resulting in those future circumstances or that future event, may be deemed to be precise information.",
    "qualification_step_2_title": "The information has not been made public.",
    "qualification_step_2_description": "Not only information published by the issuer, but also information which has actually been made public, shall be considered to be disclosed information. Whether or not the information is incorporated in the price of the financial instrument is a decisive factor in determining whether it has been made public. Factors that may be relevant in assessing this include:<br>\n- the information channel through which the information was disclosed (sectoral, local, national, etc.);<br>\n- the size of the group of people to whom the information may have been disseminated;<br>\n- the role of this group of persons in price determination (e.g. institutional investors).",
    "qualification_step_3_title": "Does the information relate directly or indirectly to the issuer or to its financial instruments?",
    "qualification_step_3_description": "Not only information directly concerning the issuer or the financial instrument(s) it issues (for example, information about the issuer's financial position, assets, liabilities, business) may constitute inside information, but also indirect information concerning other issuers or the financial instruments of other issuers.",
    "qualification_step_4_title": "If it were made public, would the information be likely to have a significant effect on the prices of the financial instruments?",
    "qualification_step_4_description": "Information which, if it were made public, would be likely to have a significant effect on the prices of financial instruments shall mean information a reasonable investor would be likely to use as part of the basis of his or her investment decisions.",
    "delay_step_1_title": "The immediate disclosure of the inside information is likely to prejudice the issuers’ legitimate interests.",
    "delay_step_1_description": "The cases where immediate disclosure of the inside information is likely to prejudice the issuers’ legitimate interests could include but are not limited to the following circumstances:<br>\n<strong> 1. </strong>the issuer is conducting negotiations, where the outcome of such negotiations would likely be jeopardised by immediate public disclosure. Examples of such negotiations may be those related to mergers, acquisitions, splits and spin-offs, purchases or disposals of major assets or branches of corporate activity, restructurings and reorganisations.<br>\n<strong> 2. </strong> the financial viability of the issuer is in grave and imminent danger, although not within the scope of the applicable insolvency law, and immediate public disclosure of the inside information would seriously prejudice the interests of existing and potential shareholders by jeopardising the conclusion of the negotiations designed to ensure the financial recovery of the issuer;<br>\n<strong> 3. </strong> the inside information relates to decisions taken or contracts entered into by the management body of an issuer which need, pursuant to national law or the issuer’s bylaws, the approval of another body of the issuer, other than the shareholders’ general assembly, in order to become effective, provided that:<br>\ni. immediate public disclosure of that information before such a definitive decision would jeopardise the correct assessment of the information by the public; and<br>\nii. the issuer arranged for the definitive decision to be taken as soon as possible.<br>\n<strong> 4. </strong>the issuer has developed a product or an invention and the immediate public disclosure of that information is likely to jeopardise the intellectual property rights of the issuer;<br>\n<strong> 5. </strong>the issuer is planning to buy or sell a major holding in another entity and the disclosure of such an information would likely jeopardise the implementation of such plan;<br>\n<strong> 6. </strong>a transaction previously announced is subject to a public authority’s approval, and such approval is conditional upon additional requirements, where the immediate disclosure of those requirements will likely affect the ability for the issuer to meet them and therefore prevent the final success of the deal or transaction.",
    "delay_step_2_title": "The inside information to be delayed is not in contrast with the latest public announcement or other type of communication by the issuer on the same matter to which the inside information refers.",
    "delay_step_2_description": "The situations in which delay of disclosure of inside information is likely to mislead the public includes at least the following circumstances:<br>\n<strong>1. </strong>the inside information whose disclosure the issuer intends to delay is materially different from the previous public announcement of the issuer on the matter to which the inside information refers to; or<br>\n<strong>2. </strong>the inside information whose disclosure the issuer intends to delay regards the fact that the issuer’s financial objectives are not likely to be met, where such objectives were previously publicly announced; or<br>\n<strong>3. </strong>the inside information whose disclosure the issuer intends to delay is in contrast with the market’s expectations, where such expectations are based on signals that the issuer has previously sent to the market, such as interviews, roadshows or any other type of communication organized by the issuer or with its approval.",
    "delay_step_3_title": "The confidentiality of the information is ensured",
    "delay_step_3_description": "This should include a description of the information barriers that prevent access to inside information by persons other than those who need to have access to it in the normal exercise of their employment, profession or duties. Such information barriers may include, among other things, physical and non-physical limitations on the ability to access information, such as an information technology access control systems at the issuer.",
    "delay_step_1_title_mar_5": "The disclosure of the inside information entails a risk of undermining the financial stability of the issuer and of the financial system",
    "delay_step_1_description_mar_5": "It should be noted that to resort to the delay under Article 17(5) of MAR, disclosure of inside information has to entail a risk of undermining the financial stability of both the issuer and the financial system.<br>\nFor the disclosure of inside information to entail a risk of undermining the stability of the financial system, it is likely for it to pertain and be performed by an institution of relevance, e.g. in terms of impact and interconnection.<br>\nIn this context, credit/financial institutions should not simply rely on ex ante categorisations but rather look at the specific circumstances.",
    "delay_step_2_title_mar_5": "It is in the public interest to delay the disclosure",
    "delay_step_2_description_mar_5": "In the absence of any definition of “public interest”, Recital 52 of MAR provides guidance stipulating that “the wider public and economic interest in delaying disclosure outweighs the interest of the market in receiving the information which is subject to delay”.<br>\nWhen assessing the public interest, the credit/financial institution should attempt to identify different entities or groups who could be directly or indirectly affected by the decision to delay the disclosure of the inside information and whose interests may be understood as a public interest. <br>\nDuring the assessment of the public interest, it is important to consider interests beyond the direct economic impacts and other non-financial interests of the public. All of these interests would need to be considered, and none of them should be considered in isolation. <br>\nIf there are divergent interests of the public, the credit/financial institution should assess on a case-by-case basis if the prevailing public interest(s) is to delay the disclosure of inside information. For example, a potential loss to investors who have made or may make an investment decision should be weighed against the adverse effect of public disclosure on other groups, such as depositors and consumers. \n",
    "delay_step_3_title_mar_5": "The confidentiality of the information can be ensured",
    "delay_step_3_description_mar_5": "Credit/financial institutions should provide the NCA with information on how the confidentiality of the inside information can be ensured.<br>\nCredit/financial institutions are expected to assess the confidentiality of the information at the time of the notification to the NCA, but also how the confidentiality can be ensured during the period in which the information might be delayed. <br>\nTo that purpose, credit/financial institutions should consider their procedures and measures put in place to ensure the confidentiality and draw up their insider list given that, pending the NCA’s decision to consent to the delay, the disclosure of the inside information is de facto already delayed.",
    "based_on_what_you_would_like_to_delay": "Do you intend to delay the disclosure of inside information under Article 17(4) of MAR (general delay) or under Article 17(5) of MAR (financial stability delay)?",
    "delay_based_on_mar_17_4": "MAR 17(4)",
    "delay_based_on_mar_17_5": "MAR 17(5)",
    "delay_type": "Delay Type",
    "created": "Created",
    "delayed": "Delay",
    "insider_information": "Insider information",
    "all_option": "All",
    "ceased_option": "Ceased",
    "published_option": "Published",
    "change_to_sensitive_list_text": "Are you sure you want to reclassify the inside information and close the related insider list?",
    "information": "Information"
  },
  "confidential-details": {
    "confidential_list": "Confidential list",
    "date_placeholder": "DD/MM/YYYY",
    "date_and_time_of_creation": "Date and time of creation of the confidential list:",
    "dt_of_last_update": "Date and time of the last update:",
    "a_brief_description_of_the_confidential_information": "Name of the Confidential List",
    "confidential_list_long_description": "Description of the Confidential Information",
    "add_new_person": "Add New Person",
    "delete": "Delete",
    "this_confidential_list_is_empty": "This Confidential List is empty. Please add at least one person to it!",
    "export_confidential_list": "Export Confidential List",
    "convert_to_a_deal_specific_insider_list": "Convert to a Deal-Specific Insider List",
    "name": "Name",
    "position": "Position",
    "email": "E-mail",
    "edit": "Edit",
    "disable_editing": "Disable Editing",
    "name_of_the_insider": "Name of the Insider",
    "data_completeness": "Data Completeness",
    "notification_emails": "Notification Email(s)",
    "resend_notification": "Resend notification email",
    "acknowledgements": "Acknowledgements",
    "last_login": "Last Login",
    "save_data": "Save Data",
    "name_of_insider": "Name of Insider",
    "email_address": "E-mail Address",
    "back": "Back",
    "do_you_want_to_delete_this_insider": "Do you want to delete this insider?",
    "permanently_delete": "Permanently Delete",
    "download_all_acknowledgements": "Download All Acknowledgements",
    "download_all_notification_emails": "Download All Notification Emails",
    "dt_of_creation_of_permanent_insider_section": "Date & Time of creation of the permanent insiders section",
    "date_of_transmission_to_competent_authority": "Date of transmission to the competent authority",
    "export_the_permanent_insider_list": "Export the Permanent Insider List",
    "first_name": "First Name",
    "surname": "Surname",
    "birth_surname": "Birth Surname",
    "professional_telephone_number": "Professional Telephone Number",
    "company_name": "Company Name",
    "company_address": "Company Address",
    "function_and_reason_for_being_insider": "Function and reason for being included",
    "function_and_reason_for_being_insider_title": "Text describing the role, function and reason for inclusion in this list",
    "function_and_reason_for_being_insider_title_reform": "Text describing role, function and reason for being on this list, including the company name and address in the case of third-party service providers.",
    "function_and_reason_for_being_insider_placeholder": "Function and Reason",
    "first_name_tooltip": "In the case of third-party service providers, the first name(s) of the natural person acting as a contact person for that third-party service provider.",
    "surname_tooltip": "In the case of third-party service providers, the surname(s) of the natural person acting as a contact person for that third-party service provider.",
    "included": "Included",
    "dt_of_persons_inclusion": "Date and time when you obtained access to the information",
    "dt_of_persons_inclusion_reform": "The date and time when the person obtained access to the specific piece of information.",
    "ceased_tooltip_reform": "The date and time when the person ceased to have access to the specific piece of information.",
    "birthdate": "Birthdate",
    "national_id_card_number": "National ID Card Number",
    "national_id_card_number_tooltip": "National ID card / passport number.",
    "national_id_card_number_tooltip_reform": "ID card or passport number.",
    "personal_telephone_number": "Personal Telephone Number",
    "personal_full_home_address": "Personal Full Home Address",
    "personal_full_home_address_title": "Country, postcode, city, street, house number",
    "mar_18_notifications": "MAR 18(2) Notifications",
    "mar_18_acknowledgements": "MAR 18(2) Acknowledgements",
    "not_logged_in_yet": "Not logged in yet",
    "select_version": "Choose version...",
    "permanent_insider_list": "Permanent Insider List",
    "insider": "insider",
    "notifications_and_acknowledgements": "Notifications and Acknowledgments",
    "last_name": "Last Name",
    "birth_last_name": "Birth Last Name",
    "obtained": "Obtained",
    "dt_of_the_entry": "Date and time of the entry of the person into the permanent insider stage (yyyy-mm-dd, hh: dd UTC)",
    "reason_for_listing": "Reason for Listing",
    "add_the_person_as_central_contract_point": "Add the person as central contact point.",
    "yes": "Yes",
    "no": "No",
    "notify_the_insider": "Notify the insider about the inclusion in the insider list, the legal and regulatory duties entailed, and the sanctions applicable to insider dealing and unlawful disclosure of inside information as per Article 18(2) of MAR.",
    "confirm": "Confirm",
    "download": "Download",
    "date_sent": "Date Sent",
    "export_insider_list": "Export Insider List",
    "discard": "Discard",
    "export": "Export",
    "function_and_reason_for_being_insider_confidential": "Function and reason for being included",
    "bulk_add_persons": "Bulk add",
    "bulk_add_modal_title": "Add multiple people from directory search",
    "bulk_add_row_user": "User",
    "bulk_add_remove_row": "Remove",
    "bulk_add_add_row": "Add another row",
    "bulk_add_submit": "Add all",
    "bulk_do_not_close_warning": "Do not close this page, reload, or navigate away until the process has finished.",
    "bulk_add_progress_created": "Created {current} / {total}",
    "bulk_add_progress_remaining": "{n} remaining",
    "bulk_results_title": "Results",
    "bulk_col_email": "Email",
    "bulk_col_name": "Name",
    "bulk_col_status": "Status",
    "bulk_col_reason": "Reason",
    "bulk_col_actions": "Remove",
    "bulk_col_notification": "Notification",
    "bulk_notification_tooltip": "When enabled, this person will be included in the next step where you can send the confidential list inclusion notification email after users are added.",
    "bulk_status_success": "Success",
    "bulk_status_failed": "Failed",
    "bulk_error_duplicate_list": "User already on this list or duplicate",
    "bulk_error_permanent_list": "User is on the permanent insider list",
    "bulk_error_server": "Server error",
    "bulk_error_generic": "Request failed",
    "bulk_continue_to_email": "Continue to notification emails",
    "bulk_close": "Close",
    "bulk_recipients_title": "Recipients (successful adds)",
    "bulk_send_all": "Send all notifications",
    "bulk_email_progress_sent": "Sent {current} / {total}",
    "bulk_email_results_title": "Notification send results",
    "bulk_form_error_min_rows": "Select at least one user from the search results.",
    "bulk_form_error_max_rows": "You can add a maximum of {max} users at once.",
    "bulk_form_error_duplicate_email": "Remove duplicate emails in the list.",
    "bulk_form_error_incomplete_row": "Each row must have a user selected from the list (no free-text email).",
    "bulk_row_error_select_email": "Select a user from the directory list.",
    "bulk_row_error_invalid_email": "Enter a valid email address.",
    "bulk_row_error_first_name": "First name is required.",
    "bulk_row_error_last_name": "Last name is required.",
    "bulk_row_error_duplicate_email": "This email is used more than once.",
    "bulk_email_search_min_chars_hint": "Type at least 5 characters to search.",
    "bulk_col_error_detail": "Details",
    "send_notification_after_bulk_add": "Send inclusion notification after successful add"
  },
  "confidential-list": {
    "closed_confidential_list": "Closed Confidential List",
    "confidential_list": "Confidential list",
    "create_new_confidential_list": "Create New Confidential List",
    "download": "Download",
    "details": "Details",
    "project_name": "Project Name",
    "date_and_time_of_creation": "Date and Time of Creation",
    "number_of_people": "Number of People",
    "short_name_of_information": "Short Name of Information",
    "dt_placeholder": "dd-mm-yyyy; hh:mm",
    "discard": "Discard",
    "create": "Create",
    "date": "Date",
    "transmission_to_authority_at": "Transmission to Authority at",
    "insider_information": "Inside Information",
    "create_insider_information": "Choose sensitive information",
    "create_new_confidential_information": "Choose new confidential information",
    "date_and_time_of_closing": "Closing date",
    "create_normal_information": "Choose specific insider information",
    "create_new_normal_information": "Choose new specific insider information"
  },
  "control-panel-data-room": {
    "market_sounding_data_room": "Market Sounding Data Room",
    "data_room_name": "Data Room Name",
    "non_market_sounding_data_room": "Non-Market Sounding Data Room",
    "this_room_contains_insider_information": "This room contains insider information"
  },
  "dashboard": {
    "todo_item": "Current tasks",
    "add_new": "Add New",
    "no_permissions": "No permissions",
    "automated_emails": "Automated E-mails",
    "pdrm_emails": "PDMR / PCA Emails",
    "pca_emails": "PCA Emails",
    "emails_related_to_a_permanent_insider_list": "Emails Related to a Permanent Insider List",
    "emails_related_to_a_transaction_specific_insider_list": "Emails Related to a Transaction-Specific Insider List",
    "emails_related_to_data_rooms": "Emails Related to Data Rooms",
    "statements_and_statistics": "Statistics",
    "per": "Per",
    "individual_percentages": "Individual-percentages",
    "comapnys_inside_information": "Company's Inside Information",
    "per_specific_confidential_pdmr": "Per., specific, confidential, PDMR",
    "manage_permissions": "Manage Permissions",
    "pdmr_pca_emails": "PDMR / PCA Emails",
    "emails_related_to_trade_ban": "Emails Related to Trade ban",
    "show_more": "Show More",
    "show_less": "Show Less",
    "search_accounts": "Search Accounts",
    "fill_in_the_following_data": "Fill in the following data",
    "change_permission": "Change Permission",
    "privileges": "Privileges",
    "no_access": "No Access",
    "read_only": "Read-Only",
    "editor": "Editor",
    "inside_information": "Inside Information",
    "insider_list": "Insider list",
    "pdmr_pca": "PDMR/PCA",
    "data_rooms": "Data rooms",
    "user_created_successfully": "User created successfully",
    "save": "Save",
    "discard": "Discard",
    "name": "Name",
    "email": "E-mail",
    "position": "Position",
    "phone_number": "Phone number",
    "add_new_user": "Add New User",
    "chart_insider_list": "Insider List",
    "chart_pdmr_pca": "PDMR/PCA",
    "chart_market_sounding": "Market Sounding",
    "previous": "Previous",
    "next": "Next",
    "users": "Users"
  },
  "data-room-details": {
    "market_sounding_data_room": "Market Sounding Data Room - { dataroom }",
    "non_market_sounding_data_room": "Classic Data Room - { dataroom }",
    "uploaded_files": "Uploaded Files",
    "people_with_access": "People with Access",
    "upload_new_documents": "Upload New Document(s)",
    "delete": "Delete",
    "download": "Download",
    "download_document_list": "Download Document List",
    "download_all_files_zip": "Download All Files (.zip)",
    "file_name": "File Name",
    "time_of_upload": "Time of Upload",
    "folder_name": "Folder Name",
    "open_folder": "Open Folder",
    "create_new_folder": "Create New Folder",
    "create": "Create",
    "discard": "Discard",
    "rename": "Rename",
    "this_file_contains_inside_information": "This file contains inside information.",
    "select_insider_information_from_the_list": "Please select the relevant inside information from the list!",
    "insider_information_related_to_the_file": "Inside information related to the file.",
    "upload_file": "Upload File",
    "yes": "Yes",
    "no": "No",
    "please_select_the_files": "Please select the files that contain inside information!",
    "upload_files": "Upload Files",
    "please_select_the_file_list": "Please check the file list before uploading!",
    "name": "Name",
    "email_address": "Email Address",
    "grant_access": "Grant Access",
    "take_away_access_from_everyone": "Withdraw All Access ",
    "take_away_access": "Withdraw access",
    "email_notifications": "E-mail Notification(s)",
    "acknowledgement": "Acknowledgement",
    "download_list_of_people_with_access": "Download List of People with Access",
    "download_notification_emails_and_statements": "Download Notification Emails and Statements",
    "personal_data": "Personal Data",
    "notification_status": "Notification Status",
    "statement_of_consent_status": "Statement Status",
    "termination_of_access": "Termination of Access",
    "telephone_number": "Telephone Number",
    "dt_placeholder": "dd-mm-yyyy; hh:mm",
    "the_person_to_be_added": "The person to be added to this data room is not yet on the insider list in respect of the following inside information",
    "name_of_inside_information": "Name of Inside Information",
    "notification_and_insider_listing": "Notification & Insider Listing",
    "address": "Address",
    "subject": "Subject",
    "body": "Body",
    "email": "Email",
    "inclusion_email_attachments": "Attachments",
    "send": "Send",
    "first_name": "First Name",
    "last_name": "Last Name",
    "phone_number": "Phone Number",
    "folders_map": "Folders Map",
    "upload": "Upload",
    "size": "Size",
    "modified": "Modified",
    "title": "Title",
    "do_you_want_to_revoke_access_to_this_person": "Do you want to withdraw access from this person?",
    "do_you_want_to_revoke_access_to_everyone": "Do you want to revoke access to everyone?",
    "delete_dataroom": "Delete Data Room",
    "are_you_sure_you_want_to_delete_this_data_room": "Are you sure you want to delete this data room?",
    "save": "Save",
    "name_of_the_data_room": "Name of the Data Room",
    "the_information_is_transferred": "The information is disclosed in the course of a market sounding.",
    "view_a_guide": "View a Guide",
    "comment": "Comment",
    "edit": "Edit",
    "cancel": "Cancel",
    "next": "Next",
    "does_the_user_have_access_to_inside_info": "Does the user have access to inside information?",
    "insider_info_access": "Inside information access",
    "details": "Details",
    "file_delete_confirmation": "Do you want to delete this File ?",
    "folder_delete_confirmation": "Do you want to delete this Folder ?",
    "folders_files_delete_confirmation": "Do you want to delete the selected folders/files ?",
    "back": "Back",
    "consent_statement": "Consent Statement",
    "change_dataroom_upload_size": "Change Data Room Upload Size",
    "max_upload_size": "Max Upload Size",
    "send_notification_to": "Send Notification to",
    "users": "Users",
    "send_email_to": "Send e-mail to:",
    "restore": "Restore",
    "notification_sent": "Notification Sent",
    "out_of": "out of",
    "max_list_per_year": "Max Lists Per Year",
    "lists": "Lists",
    "no_decrypted_data": "Decryption is in progress. Please contact your investor relations representative if necessary.",
    "file_size_too_big": "The maximum filesize for a single file is 300 MB.",
    "file_already_exists": "already exists",
    "type_email_instead": "Type email manually",
    "email_user_search_loading": "Searching users…",
    "email_autofill_search_hint": "(user search suggestions from 5+ characters)"
  },
  "data-rooms": {
    "create_a_new_data_room": "Create a New Data Room",
    "market_sounding_data_room": "Market Sounding Data Room",
    "non_market_sounding_data_room": "Classic Data Room",
    "name_of_the_data_room": "Name of the data room",
    "the_information_is_transferred": "The information is disclosed in the course of a market sounding.",
    "view_a_guide": "View A Guide",
    "create": "Create",
    "cancel": "Cancel",
    "next": "Next",
    "save": "Save",
    "restore": "Restore",
    "delete": "Delete"
  },
  "delay-insider-information": {
    "delaying_inside_information": "Delaying Insider Information",
    "delaying_the_disclosure_of_inside_information": "Delaying the Disclosure of Inside Information",
    "current_date_and_time": "Date and time of delay",
    "it_can_be_modified": "(it can be modified)",
    "uploaded_files": "Uploaded Files",
    "upload_file": "Upload File",
    "attention_the_selected_files_are_uploading": " Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
    "discard": "Discard",
    "save": "Save",
    "the_conditions_of_delaying": "The conditions of delaying the disclosure of inside information as prescribed by Article 17(4) of MAR are not met. Please disclose the inside information as soon as possible!",
    "back": "Back",
    "publish": "Publish",
    "the_recorded_delay_data_will_not_be_clumped": "If you proceed, the data concerning the delay will be lost!",
    "proceed": "Proceed",
    "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
    "ok": "Ok",
    "files_uploaded_successfully": "Files uploaded successfully!",
    "date_of_delay": "Date of delay",
    "delay": "Delay"
  },
  "dropdown": {
    "settings": "Settings",
    "pdmr": "PDMR",
    "pca": "PCA",
    "dashboard": "Dashboard",
    "my_subscription": "Subscription",
    "era_form_filler": "ERA Form Filler",
    "billing_data": "Billing Data",
    "billing": "Billing",
    "change_password": "Change password",
    "login_history": "Login history",
    "edit_master_key": "Edit Master Key",
    "logout": "Logout",
    "era_settings": "ERA Settings",
    "users": "Users"
  },
  "edit-contact": {
    "contact_details": "Contact Details",
    "clients_name": "Client's name",
    "clients_address": "Client's address",
    "clients_company_registration_number": "Client's Company Registration Number",
    "investor_contacts_name": "Investor Contact's Name",
    "investor_contacts_position": "Investor Contact's Position",
    "investor_contacts_email_address": "Investor Contact's Email Address",
    "investor_contacts_phone_number": "Investor Contact's Phone Number",
    "subscribed_package": "Subscribed Package",
    "regulated_market": "Regulated Market",
    "sme": "SME",
    "advisory": "Advisory",
    "discard": "Discard",
    "save": "Save",
    "email_address": "Email Address",
    "tax_number": "Tax Number",
    "data_protection_officer": "Data Protection Officer"
  },
  "era-settings": {
    "era_settings": "ERA Settings",
    "version_era": "ERA Version",
    "version_extension": "Extension Version",
    "save": "Save",
    "era_settings_updated": "ERA settings updated"
  },
  "era": {
    "era_form_filler": "ERA Form Filler",
    "description": "For using the ERA interface, Mabureg has a browser add-on, which can be used to speed up the filling of forms by transferring data from Mabureg.",
    "steps_phrase": "To use it, follow these steps:",
    "step_1": "The browser extension can be downloaded using the link below. The browser extension can be installed on Google Chrome browser, but is also available on Edge and Opera (you need to enable installation from the Chrome Webstore).",
    "step_2": "The downloaded browser add-on must then be installed, something to enable. For some browser versions this is automatic.",
    "step_3": "Once installed, the browser add-on is ready to use. All that is required is for the user to log in to the Mabureg web application, as the browser add-on does not have a separate login, it uses the Mabureg application and calls it to make the downloadable forms data available in it.",
    "step_4": "To fill in the forms, you need to open the form in the ERA interface, after which the browser add-on will offer you the options to fill in the form.",
    "end": "If the ERA system is updated, the browser add-on must also be updated. To do this, the browser add-on will display an error message.",
    "send_to_era": "Send to ERA",
    "download_email": "Download email",
    "choose_action": "Choose action",
    "download_extension": "Download extension"
  },
  "footer": {
    "requesting_an_offer": "Requesting an Offer",
    "contact_us": "Contact us",
    "privacy_policy": "Privacy Policy",
    "terms_and_conditions": "Terms and Conditions",
    "sitemap": "Sitemap",
    "cookies": "Cookies Statement",
    "back_to_top": "Back to top",
    "copyright_and_authorship_information": "Copyright (c) 2025 Mabureg Compliance Kft. &#124; All rights reserved.",
    "english": "English",
    "hungarian": "Hungarian",
    "it_security": "IT Security",
    "attention_currently_there_is_a_trade-ban_period": "Attention! Currently there is a trading ban period."
  },
  "globals": {
    "components": {
      "base": {
        "form": {
          "the_password_must_contain_at_least_one_uppercase_letter_and_one_lowercase_letter": "The password must contain at least one uppercase letter and one lowercase letter.",
          "the_password_must_contain_at_least_one_symbol": "The password must contain at least one symbol.",
          "the_password_must_contain_at_least_one_number": "The password must contain at least one number.",
          "the_confirm_password_must_match_the_password": "The confirm password must match the password."
        },
        "charts": {
          "no_data_available": "No data available",
          "insider_list_information": "Insider List Information",
          "insider_list_statements": "Insider List Statements",
          "insider_list_count": "Number of Insider Lists",
          "insider_list_user_count": "Insider List User Count",
          "market_sounding": "Market sounding"
        }
      },
      "pages": {
        "classification": {
          "general": {
            "short_name": "Short Name of Insider Information",
            "date_identified": "Date when identified",
            "date_of_delay": "Date of Delay",
            "delay_occured": "Delay occured",
            "ceased": "Ceased",
            "statement_is": "Statement is",
            "fulfilled": "fulfilled",
            "not_fulfilled": "not fulfilled",
            "reason_for_delay": "Reason for Delay"
          },
          "current_insider_info_tab": {
            "make_public": "Make public",
            "delete": "Delete",
            "do_you_want_to_cease": "Do you want to Cease the Insider Information?",
            "back": "Back",
            "cease": "Cease",
            "edit": "Edit",
            "disable": "Disable"
          },
          "discontinued_insider_info_tab": {
            "delayed": "Delayed",
            "published_ceased": "Published / Ceased",
            "published": "Published",
            "delay_not_occured": "Delay not occured"
          },
          "information_not_classified_tab": {
            "reclassification_of_information": "Reclassification of information",
            "date_of_qualification": "Date of Qualification"
          },
          "qualification_form": {
            "conceptual_elements_of_inside_information": "Conceptual Elements of Inside Information",
            "add_comment": "Add Comment"
          },
          "static_carousel_content": {
            "comment": "Comment"
          },
          "table_body_details": {
            "decision_information": "Decision informations",
            "download_file": "Download file",
            "export": "Export",
            "modify": "Modify"
          }
        },
        "common": {
          "general": {
            "name": "Name",
            "email": "E-mail",
            "position": "Position",
            "phone_number": "Phone number",
            "zip_code": "Zip code",
            "city": "City",
            "address": "Address",
            "select_contract": "Select contract",
            "subscriptions": "Subscriptions",
            "contracts": "Contracts",
            "invoices": "Invoices",
            "view_client": "View Client",
            "client": "Client",
            "create_billingo_partner": "Create Billingo Partner",
            "invoice_number": "Invoice Number",
            "download_invoice": "Download Invoice",
            "new_invoice": "New Invoice",
            "save_new_invoice": "Save New Invoice",
            "date": "Date",
            "download_contract": "Download Contract",
            "new_contract": "New Contract",
            "upload_contract": "Upload Contract",
            "package": "Package",
            "period": "Period",
            "monthly": "Monthly",
            "yearly": "Yearly",
            "start_date": "Start Date",
            "end_date": "End Date",
            "new_subscription": "New Subscription",
            "finalize_subscription": "Finalize Subscription (Won't renew)",
            "save": "Save",
            "delay_occurred": "Delay occurred",
            "do_you_want_to_delete_the_insider_information": "Do you want to Delete the Insider Information?",
            "create_confidential_list": "Create Confidential List",
            "discard": "Discard"
          },
          "company_info": {
            "name": "Name",
            "company_registration_number": "Company Registration Number",
            "headquarters": "Headquarters",
            "tax_number": "Tax Number",
            "lei_number": "LEI Number",
            "data_protection_officer": "Data Protection Officer"
          },
          "email_attachment": {
            "date_sent": "Date Sent",
            "download": "Download"
          },
          "email_template": {
            "subject": "Subject",
            "body": "Body",
            "save": "Save",
            "cancel": "Cancel",
            "edit": "Edit",
            "send": "Send"
          },
          "permission": {
            "modify": "Modify",
            "remove_access": "Remove access",
            "pdmr_pca_transactions": "PDMR / PCA transactions",
            "user_permission_successfully_removed": "User permission successfully removed",
            "no_access": "Currently no other person has access to the system.",
            "read_only": "Read Only",
            "full_acccess": "Full Access"
          },
          "text_area_attachment": {
            "attachments": "Attachments"
          }
        },
        "data_room": {
          "general": {
            "grant_access": "Grant Access",
            "people_with_access": "People with Access",
            "take_away_access_from_everyone": "Take Away Access From Everyone",
            "take_away_access": "Take Away Access",
            "email_notifications": "E-mail Notification(s)",
            "acknowledgement": "Acknowledgement",
            "download": "Download",
            "download_list_of_people_with_access": "Download List of People with Access",
            "download_notification_emails_and_statements": "Download Notification Emails and Statements",
            "personal_data": "Personal Data",
            "notification_status": "Notification Status",
            "statement_of_consent_status": "Statement of Consent Status",
            "termination_of_access": "Termination of access",
            "name": "Name",
            "email_address": "Email Address",
            "telephone_number": "Telephone Number",
            "dt_placeholder": "dd-mm-yyyy; hh:mm"
          },
          "uploaded_files_tab": {
            "upload_new_documents": "Upload New Document(s)",
            "delete": "Delete",
            "download": "Download",
            "download_document_list": "Download Document List",
            "download_all_files_zip": "Download All Files (.zip)",
            "file_name": "File Name",
            "time_of_upload": "Time of Upload",
            "folder_name": "Folder Name",
            "open_folder": "Open Folder",
            "create_new_folder": "Create New Folder",
            "create": "Create",
            "discard": "Discard",
            "rename": "Rename"
          }
        },
        "insider_details": {
          "insider_list": {
            "date_placeholder": "DD/MM/YYYY",
            "dt_of_creation_of_permanent_insider_section": "(Date & Time of creation of the permanent insiders section)",
            "dt_of_last_update": "(Date & Time of the last update)",
            "date_of_transmission_to_competent_authority": "(Date of transmission to the competent authority)",
            "project_name": "Project Name",
            "inside_information": "Inside Information",
            "add_new_person": "Add New Person",
            "export_insider_list": "Export Insider List",
            "delete": "Delete",
            "first_name": "First Name",
            "surname": "Surname",
            "birth_surname": "Birth Surname",
            "professional_telephone_number": "Professional Telephone Number",
            "companys_name": "Company's Name",
            "companys_address": "Company's Address",
            "function_and_reason_for_being_insider": "Function and reason for being insider",
            "function_and_reason_for_being_insider_title": "Text describing the role, function and reason for inclusion in this list",
            "function_and_reason_for_being_insider_placeholder": "Function and Reason",
            "included": "Included",
            "obtained": "Obtained",
            "ceased": "Ceased",
            "birthdate": "Birthdate",
            "national_id_card_number": "National ID Card Number",
            "personal_telephone_number": "Personal Telephone Number",
            "personal_full_home_address": "Personal Full Home Address",
            "personal_full_home_address_title": "Country, postcode, city, street, house number",
            "discard": "Discard",
            "save_data": "Save Data",
            "this_insider_information_was_disclosed": "This inside information was disclosed in the course of market sounding.",
            "sending_the_notice_is_a_legal_obligation": "Sending the notice is a legal obligation. Are you sure you do not want to send the notification?",
            "name_of_the_insider": "Name of the Insider",
            "data_completeness": "Data Completeness",
            "last_login": "Last Login",
            "do_you_want_to_delete_this_insider": "Do you want to delete this insider?",
            "back": "Back"
          },
          "insider_notifications": {
            "download_all_acknowledgements": "Download All Acknowledgements",
            "download_all_notification_emails": "Download All Notification Emails",
            "name_of_insider": "Name of Insider",
            "email_address": "Email Address"
          }
        },
        "packages": {
          "general": {
            "request": "Request",
            "package_name": "Package Name",
            "function_module": "Function Module"
          },
          "package_feature_collapse": {
            "optional": "Optional"
          }
        },
        "pdma": {
          "general": {
            "modify": "Modify",
            "discard": "Discard",
            "save": "Save",
            "delete": "Delete",
            "date_placeholder": "yyyy.mm.dd",
            "notifications_list_empty": "The list of notifications is empty."
          },
          "insider_card": {
            "project_name": "Project Name",
            "first_name": "First Name",
            "surname": "Surname",
            "birth_surname": "Birth Surname",
            "professional_telephone_number": "Professional Telephone Number",
            "companys_name": "Company's Name",
            "companys_address": "Company's Address",
            "function_and_reason_for_being_insider": "Function and reason for being insider",
            "function_and_reason_for_being_insider_title": "Text describing the role, function and reason for inclusion in this list",
            "function_and_reason_for_being_insider_placeholder": "Reason",
            "obtained": "Obtained",
            "ceased": "Ceased",
            "birthdate": "Birthdate",
            "national_id_card_number": "National ID Card Number",
            "personal_telephone_number": "Personal Telephone Number",
            "personal_full_home_address": "Personal Full Home Address",
            "notification_email": "Notification Email",
            "acknowledgement": "Acknowledgement"
          },
          "legal_form": {
            "company_name": "Company Name",
            "headquarters": "Headquarters",
            "company_registration_number": "Company Registration Number",
            "date_of_inclusion": "Date of Inclusion",
            "type_of_relationship": "Type of Relationship",
            "email_address": "Email Address",
            "phone_number": "Phone number",
            "delete_pca": "Delete PCA",
            "download_notification": "Download Notification"
          },
          "natural_form": {
            "name": "Name",
            "first_name": "First Name",
            "last_name": "Last Name",
            "type_of_relationship": "Type of Relationship",
            "email_address": "Email Address",
            "phone_number": "Phone number",
            "id_number": "ID Number",
            "place_of_birth": "Place of Birth",
            "date_of_birth": "Date of Birth",
            "time_of_inclusion": "Date of Inclusion",
            "download_notification": "Download Notification"
          },
          "notification_tab": {
            "name_of_the_person": "Name of the Person",
            "email_address": "Email Address",
            "no_data_to_show": "No data to show",
            "download_all_notifications": "Download All Notification"
          },
          "pca_card": {
            "pca_name": "PCA Name",
            "pca_email_address": "PCA Email Address",
            "natual_person": "Natual Person",
            "legal_person": "Legal Person"
          },
          "pdmr_list_tab": {
            "add_new": "Add New",
            "add_new_pdmr": "Add New PDMR",
            "add_new_pca": "Add New PCA",
            "position_at_client": "Position at Client",
            "phone_number": "Phone Number",
            "place_of_birth": "Place of Birth",
            "date_of_birth": "Date of Birth",
            "id_number": "ID Number",
            "date_of_inclusion": "Date of Inclusion",
            "registered_seat": "Registered Seat",
            "registration_number": "Registration Number",
            "download_list": "Download List",
            "pdmr_pca_data": "PDMR/PCA Data",
            "date_completeness": "Data Completeness",
            "notification_status": "Notification Status",
            "successful_modification": "Successful Modification",
            "successful_deletion": "Successful Deletion",
            "modify": "Modify",
            "save": "Save",
            "discard": "Discard",
            "delete": "Delete",
            "back": "Back",
            "first_name": "First Name",
            "last_name": "Last Name",
            "email_address": "Email Address",
            "sync_data": "Sync Data",
            "attention_data_is_not_up_to_date": "Attention! Data is not up to date.",
            "do_you_want_to_delete_this_pdmr_pca": "Do you want to delete this PDMR/PCA?"
          }
        },
        "permanent_insider_list": {
          "general": {
            "name_of_insider": "Name of Insider",
            "email_address": "E-mail Address",
            "date_placeholder": "DD/MM/YYYY",
            "delete": "Delete",
            "discard": "Discard",
            "back": "Back",
            "do_you_want_to_delete_this_insider": "Do you want to delete this insider?"
          },
          "insider_collapse": {
            "notification_emails": "Notification Email(s)",
            "acknowledgements": "Acknowledgements"
          },
          "notification_and_acknowledgement": {
            "download_all_acknowledgements": "Download All Acknowledgements",
            "download_all_notification_emails": "Download All Notification Emails"
          },
          "permanent_insider_list": {
            "dt_of_creation_of_permanent_insider_section": "(Date & Time of creation of the permanent insiders section)",
            "dt_of_last_update": "(Date & Time of the last update)",
            "date_of_transmission_to_competent_authority": "(Date of transmission to the competent authority)",
            "export_the_permanent_insider_list": "Export the Permanent Insider List",
            "first_name": "First Name",
            "surname": "Surname",
            "birth_surname": "Birth Surname",
            "professional_telephone_number": "Professional Telephone Number",
            "company_name": "Company Name",
            "company_address": "Company Address",
            "function_and_reason_for_being_insider": "Function and reason for being insider",
            "function_and_reason_for_being_insider_title": "Text describing the role, function and reason for inclusion in this list",
            "function_and_reason_for_being_insider_placeholder": "Function and Reason",
            "included": "Included",
            "dt_of_persons_inclusion": "The date and time of the person's inclusion in the permanent insiders section (yyyy-mm-dd, hh:mm UTC).",
            "birthdate": "Birthdate",
            "national_id_card_number": "National ID Card Number",
            "personal_telephone_number": "Personal Telephone Number",
            "personal_full_home_address": "Personal Full Home Address",
            "personal_full_home_address_title": "Country, postcode, city, street, house number",
            "save_data": "Save Data",
            "name_of_the_insider": "Name of the Insider",
            "data_completeness": "Data Completeness",
            "last_login": "Last Login",
            "mar_18_notifications": "MAR 18(2) Notifications",
            "mar_18_acknowledgements": "MAR 18(2) Acknowledgements",
            "not_logged_in_yet": "Not logged in yet",
            "select_version": "Select Version"
          }
        },
        "serviceprovider": {
          "client_card": {
            "package_subscribed_and_extras": "Package subscribed & Extras",
            "modify_data_and_subscribed_package": "Modify data and subscribed package",
            "invoices_sent_to_customer": "Invoices Sent To Customer",
            "download_invoice": "Download Invoice",
            "download_document": "Download Document",
            "invoice_number": "Invoice Number",
            "contracts": "Contracts",
            "contract_name": "Contract Name",
            "contract_date": "Contract Date",
            "upload_a_new_contract": "Upload a new contract"
          }
        }
      },
      "tools": {
        "alert": {
          "this_list_is_empty": "This list is empty"
        },
        "attachment": {
          "dt_when_persons_access_ceased": "Date and time when the person's access to inside information ceased (yyyy-mm-dd, hh: dd UTC)"
        },
        "carousel": {
          "previous": "Previous",
          "next": "Next"
        },
        "chart": {
          "view_statistic": "View Statistic"
        },
        "custom_date": {
          "dt_placeholder": "yyyy.mm.dd hh.mm",
          "date_placeholder": "yyyy.mm.dd"
        },
        "custom_dropdown": {
          "choose": "Choose"
        },
        "editable_table": {
          "volume": "Volume",
          "price": "Price",
          "cur": "CUR",
          "add_row": "Add row"
        },
        "progess_bar": {
          "step": "Step"
        },
        "slider_table": {
          "previous": "Previous",
          "next": "Next"
        }
      }
    },
    "modals": {
      "general": {
        "first_name": "First Name",
        "full_name": "Full Name",
        "surname": "Surname",
        "last_name": "Last Name",
        "email_address": "Email Address",
        "email": "E-mail",
        "position": "Position",
        "discard": "Discard",
        "confirm": "Confirm",
        "phone_number": "Phone Number",
        "save": "Save",
        "add": "Add",
        "next": "Next",
        "birth_last_name": "Birth Last Name",
        "inclusion_email_attachments": "Attachments (These files can be downloaded and attached to the notification email)"
      },
      "classification": {
        "information_form": {
          "please_provide_information": "Please provide information on the disclosure of inside information.",
          "link": "Link",
          "k_number": "K-Number",
          "date_and_time_of_publication": "Date and time of publication",
          "upload_file": "Upload File",
          "approve": "Approve"
        },
        "information_notification": {
          "pursuant_to_article_17_4": "Pursuant to Article 17(4) of MAR, where an issuer has delayed the disclosure of inside information, it shall inform the competent authority that disclosure of the information was delayed and shall provide a written explanation of how the conditions set out in Article 17(4) were met, immediately after the information is disclosed to the public."
        }
      },
      "data_rooms": {
        "general": {
          "yes": "Yes",
          "no": "No"
        },
        "grant_access_form": {
          "address": "Address",
          "grant_access": "Grant Access"
        },
        "grant_access_modal": {
          "the_person_to_be_added": "The person to be added to this data room is not yet on the insider list in respect of the following inside information",
          "name_of_inside_information": "Name of Inside Information",
          "notification_and_insider_listing": "Notification & Insider Listing"
        },
        "insider_individuals": {
          "the_following_individuals": "The following individuals are not on the respective insider lists",
          "name_of_inside_information": "Name of Inside Information",
          "name": "Name",
          "notification_and_insider_listing": "Notification & Insider Listing",
          "email_address": "Email Address",
          "discard": "Discard"
        },
        "market_sounding_check": {
          "the_market_sounding_check": "The market sounding will involve the disclosure of inside information.",
          "pursuant_of_article_11": "Pursuant to Article 11 (3) of the MAR, you must justify the reasons for the above conclusion.",
          "create_a_data_room": "Create a Data Room",
          "discard": "Discard",
          "yes": "Yes",
          "no": "No",
          "comment": "Comment"
        },
        "multiple_files_indider": {
          "please_select_the_inside_information": "Please select the inside information from the drop-down list and assign them to the files selected!",
          "select_insider_information_from_the_list": "Select Insider Information from the List!",
          "select_all": "Select All",
          "file_name": "File Name",
          "select_insider_information": "Select Insider Information"
        },
        "new_data_room": {
          "name_of_the_data_room": "Name of the data room",
          "the_information_is_transferred": "The information is transferred in the course of a market sounding.",
          "view_a_guide": "View A Guide",
          "create": "Create"
        },
        "transcription_description": {
          "description_of_the_transaction_subject": "Description of the Transaction Subject to Market Sounding"
        },
        "upload_file_confirm": {
          "file_name": "File Name",
          "this_file_contains_inside_information": "This file contains inside information.",
          "select_insider_information_from_the_list": "Select Insider Information from the List!",
          "insider_information_related_to_the_file": "Insider information related to the file.",
          "upload_file": "Upload File",
          "discard": "Discard",
          "yes": "Yes",
          "no": "No"
        },
        "upload_multiple_files": {
          "please_select_the_files": "Please select the files that contain inside information!",
          "upload_files": "Upload Files",
          "discard": "Discard"
        },
        "upload_multiple_files_confirm": {
          "please_select_the_file_list": "Please check the file list before uploading!",
          "file_name": "File Name",
          "name": "Name",
          "email_address": "Email Address",
          "upload_files": "Upload Files",
          "discard": "Discard"
        }
      },
      "pdmr_pca": {
        "general": {
          "place_of_birth": "Place of Birth",
          "date_of_birth": "Date of Birth",
          "id_number": "ID Number",
          "date_of_inclusion": "Date of Inclusion"
        },
        "new_pca_form": {
          "add_new_pca": "Add New PCA",
          "related_pdmr": "Related PDMR",
          "please_choose": "Please Choose...",
          "default_select_example": "Default select example",
          "nature_of_the_relationship": "Nature of the relationship",
          "please_choose_a_pdmr": "Please choose a PDMR and a type of relation!"
        },
        "new_pca_legal": {
          "add_new_pca": "Add New PCA",
          "company_name": "Company Name",
          "registered_seat": "Registered Seat",
          "companys_registration_number": "Company's Registration Number",
          "date_of_inclusion": "Date of Inclusion",
          "notify_pdrm": "Notify PDMR of his/her obligations under MAR.",
          "entry_of_the_pca_in_the_register": "Entry of the PCA in the register",
          "pursuant_to_article_19_5": "Pursuant to Article 19(5), issuers shall notify the PDMRs of their obligations under MAR in writing. Are you sure you do not want to send this notification?",
          "email_address": "Email Address",
          "phone_number": "Phone Number"
        },
        "new_pca_natural": {
          "add_new_pca": "Add New PCA",
          "notify_pdmr": "Notify PDMR of his/her obligations under MAR.",
          "notify_pca": "Notify PCA of his/her obligations under MAR.",
          "entry_of_the_pca_in_the_register": "Entry of the PCA in the register",
          "notification_to_mar_is_a_legal": "Notification to MAR is a legal obligation to send. Are you sure you do not want to send this notification?"
        },
        "new_pdmr_form": {
          "add_new_pdrm": "Add New PDMR",
          "position_at_client": "Position at Client",
          "send_a_mar_notification": "Send a MAR notification at the same time as recording",
          "entry_of_the_pdrm_in_the_register": "Entry of the PDMR in the register",
          "notification_to_mar_is_a_legal": "Notification to MAR is a legal obligation to send. Are you sure you do not want to send this notification?"
        },
        "pdmr_pca_options": {
          "add_new_pdrm_pca": "Add New PDMR / PCA",
          "add_new_pdrm": "Add New PDMR",
          "add_new_pca": "Add New PCA"
        },
        "previous_notifications": {
          "pdrm_name": "PDMR Name",
          "date_sent": "Date Sent",
          "dt_placeholder": "yyyy.mm.dd hh:mm",
          "notification_email": "Notification Email"
        }
      },
      "add_new_person_insider": {
        "send_notification": "Would you like to notify the person you want to add about being added to the precautionary list?",
        "obtained": "Obtained",
        "dt_of_the_entry": "Date and time of the entry of the person into the permanent insider stage (yyyy-mm-dd, hh: dd UTC)",
        "function_and_reason_for_being_insider": "Function and reason for being insider",
        "reason_for_listing": "Reason for Listing",
        "add_the_person_as_central_contract_point": "Add the person as central contact point.",
        "yes": "Yes",
        "no": "No",
        "notify_the_insider": "Notify the insider about the inclusion in the insider list, the legal and regulatory duties entailed, and the sanctions applicable to insider dealing and unlawful disclosure of inside information as per Article 18(2) of MAR."
      },
      "change_data_form": {
        "change_data": "Change Data",
        "name": "Name"
      },
      "insider_date_form": {
        "please_indicate_the_date": "Please indicate the date the listing was submitted!",
        "creating_dt": "Creating Date & Time",
        "permanent_insider_list_created": "Permanent insider list successfully created!",
        "permanent_insider_list_updated": "Permanent insider list successfully updated!",
        "created_at_update": "Please, give the date when the list has been created.",
        "updated_at_update": "Please, give the date when the list were last updated.",
        "submitted_at_update": "Please, give the date when the list were submitted ti the authorities."
      },
      "notification_alert": {
        "no": "No",
        "yes": "Yes"
      },
      "provide_link": {
        "link": "Link"
      }
    },
    "views": {
      "pages": {
        "admin": {
          "new_contract": {
            "contact_details": "Contact Details",
            "clients_name": "Client's name",
            "clients_address": "Client's address",
            "clients_company_registration_number": "Client's Company Registration Number",
            "investor_contacts_name": "Investor Contact's Name",
            "investor_contacts_position": "Investor Contact's Position",
            "investor_contacts_email_address": "Investor Contact's Email Address",
            "investor_contacts_phone_number": "Investor Contact's Phone Number",
            "subscribed_package": "Subscribed Package",
            "regulated_market": "Regulated Market",
            "sme": "SME",
            "advisory": "Advisory",
            "discard": "Discard",
            "save": "Save",
            "email_address": "Email Address",
            "tax_number": "Tax Number",
            "data_protection_officer": "Data Protection Officer"
          },
          "service_provider_control_panel": {
            "clients": "Clients",
            "add_a_new_client": "Add a New Client",
            "search_by_name": "Search by Name",
            "actions": "Actions",
            "package_num": "Package {num}",
            "send_email_to_customers": "Send Email to Customers",
            "automated_emails": "Automated E-mails",
            "pdmr_emails": "PDMR Emails",
            "pca_emails": "PDMR Emails",
            "emails_related_to_a_permanent_insider_list": "Emails Related to a Permanent Insider List",
            "emails_related_to_a_transaction_specific_insider_list": "Emails Related to a Transaction-Specific Insider List",
            "emails_related_to_data_rooms": "Emails Related to Data Rooms",
            "open_folder": "Open Folder",
            "folder_name": "Folder Name",
            "template_name": "Template Name",
            "email_templates": "Email Templates",
            "edit_template": "Edit Template",
            "category": "Category",
            "type": "Type",
            "template_name_en": "Template Name (EN)",
            "template_name_hu": "Template Name (HU)",
            "subject_en": "Subject (EN)",
            "subject_hu": "Subject (HU)",
            "body_en": "Body (EN)",
            "body_hu": "Body (HU)",
            "category_required": "Category is required",
            "type_required": "Type is required",
            "template_name_hu_required": "Template Name (HU) is required",
            "template_name_en_required": "Template Name (EN) is required",
            "subject_hu_required": "Subject (HU) is required",
            "subject_en_required": "Subject (EN) is required",
            "body_hu_required": "Body (HU) is required",
            "body_en_required": "Body (EN) is required",
            "template_saved_successfully": "Template saved successfully"
          }
        },
        "authentication": {
          "general": {
            "login_to_mabureg": "Login to MABUREG",
            "create_new_client": "Create new MABUREG client",
            "new_client_created_successfully": "New client created successfully",
            "this_is_your_account_uid": "This is your account UID:"
          },
          "login": {
            "enter_your_email_below": "Enter your email below",
            "email_address_phone_number": "Email Address / Phone Number",
            "email_address": "Email Address",
            "log_in": "Log in",
            "password": "Password",
            "forgot_password": "Forgot password?",
            "new_client": "Create new client",
            "confirm_password": "Confirm password",
            "phone_number": "Phone number",
            "register": "Register"
          },
          "login_code": {
            "a_verification_code_has_been_sent": "A verification code has been sent to your email / phone. This code is valid for 10 minutes.",
            "code": "Code",
            "verify_login": "Verify & Login"
          },
          "login_code_verification": {
            "please_wait_while_we_verify_your_token": "Please wait, while we verify your token!"
          },
          "market_data_room_access_person": {
            "download_the_document_list": "Download The Document List",
            "download_all_files": "Download All Files",
            "download_document": "Download Document",
            "file_name": "File Name",
            "uploaded": "Uploaded"
          },
          "new_password": {
            "reset_your_password": "Reset your password",
            "enter_your_registered_email_address": "Enter your registered E-mail & we will send to you a password reset link.",
            "new_password": "New password",
            "reset_password": "Reset password",
            "email_address": "Email Address",
            "enter_your_new_password": "Enter your new password",
            "confirm_password": "Confirm password",
            "repeat_password": "Repeat password",
            "dont_have_an_account": "Don't have an account?",
            "sign_up": "Sign up",
            "uid_info": "Leave blank if you don't know your UID"
          },
          "password_code": {
            "reset_your_password": "Reset your password",
            "enter_your_registered_email_address": "Enter your registered e-mail and we will send to you a password reset link.",
            "code": "Code",
            "enter_code": "Enter Code",
            "continue": "Continue",
            "didnt_receive_code_yet": "Didn't receive code yet?",
            "resend_link": "Resend link"
          },
          "terms": {
            "please_read_the_terms_carefully": "Please read the terms carefully",
            "please_provide_us_with_the_following": "Please provide us with the following data",
            "phone_number": "Phone Number",
            "address": "Address",
            "go_to_the_data_room": "Go To The Data Room"
          },
          "user_logins": {
            "my_logins": "My Logins",
            "other_logins": "Other Logins",
            "search_by_name_email": "Search by Name, E-mail",
            "name_and_email_address": "Name & E-mail Address",
            "device": "Device"
          }
        },
        "classification": {
          "classification_insider_info": {
            "qualification_and_delay_of_inside_information": "Qualification and Delay of Inside Information",
            "add_new_information": "Add New Information",
            "current_inside_information": "Current Inside Information",
            "previous_inside_information": "Previous Inside Information",
            "sensitive_information": "Sensitive Information"
          },
          "delay_insider_information": {
            "delaying_inside_information": "Delaying Insider Information",
            "delaying_the_disclosure_of_inside_information": "Delaying the Disclosure of Inside Information",
            "current_date_and_time": "Current Date & Time",
            "it_can_be_modified": "(it can be modified)",
            "uploaded_files": "Uploaded Files",
            "upload_file": "Upload File",
            "attention_the_selected_files_are_uploading": " Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
            "discard": "Discard",
            "save": "Save",
            "the_conditions_of_delaying": "The conditions of delaying the disclosure of inside information as prescribed by Article 17(4) of MAR are not met. Please disclose the inside information as soon as possible!",
            "back": "Back",
            "publish": "Publish",
            "the_recorded_delay_data_will_not_be_clumped": "The recorded delay data will not be clumped, but insider information will be saved!",
            "proceed": "Proceed",
            "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
            "ok": "Ok",
            "files_uploaded_successfully": "Files uploaded successfully!"
          },
          "information_re_qualification": {
            "requalification_of_information": "Requalification of Information",
            "project_name": "Project Name",
            "please_indicate_the_name_of_the_project": "Please indicate the name of the project (e.g. merger, project MABU, etc.). It is important that this field cannot contain any inside information.",
            "description_of_the_information": "Description of the Information to be Qualified",
            "current_date_and_time": "Current Date & Time",
            "it_can_be_modified": "(it can be modified)",
            "uploaded_files": "Uploaded Files",
            "upload_file": "Upload File",
            "attention_the_selected_files_are_uploading": " Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
            "discard": "Discard",
            "save": "Save",
            "the_conditions_of_delaying": "The conditions of delaying the disclosure of inside information as prescribed by Article 17(4) of MAR are not met. Please disclose the inside information as soon as possible!",
            "back": "Back",
            "publish": "Publish",
            "the_recorded_delay_data_will_not_be_clumped": "The recorded delay data will not be clumped, but insider information will be saved!",
            "proceed": "Proceed",
            "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
            "ok": "Ok",
            "files_uploaded_successfully": "Files uploaded successfully!"
          },
          "new_information_qualification": {
            "reclassify_the_information": "Reclassify The Information",
            "requalification_of_information": "Qualification of New Information",
            "project_name": "Project Name",
            "please_indicate_the_name_of_the_project": "Please indicate the name of the project (e.g. merger, project MABU, etc.). It is important that this field cannot contain any inside information.",
            "description_of_the_information": "Description of the Information to be Qualified",
            "current_date_and_time": "Current Date & Time",
            "it_can_be_modified": "(it can be modified)",
            "uploaded_files": "Uploaded Files",
            "upload_file": "Upload File",
            "attention_the_insider_information_is_being_created": "Attention! This insider information is being created, please do not close the window, or proceed anywhere!",
            "attention_the_selected_files_are_uploading": "Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
            "discard": "Discard",
            "classify_information": "Classify The Information",
            "what_do_you_want_to_do_with_the_information": "What do you want to do with the information?",
            "delay": "Delay",
            "immediate_publication": "Immediate Publication",
            "this_information_does_not_qualify": "This information does not qualify as inside information. Do you want to create a confidential list?",
            "no": "No",
            "yes": "Yes",
            "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
            "ok": "Ok",
            "files_uploaded_successfully": "Files uploaded successfully!",
            "successfully_created": "Successfully created!",
            "edit_the_information": "Edit the information",
            "confirm_edit_the_information": "Confirm Edit the information",
            "do_you_want_to_Reclassify_the_information": "Do you want to Reclassify the information",
            "save_changes": "Save Changes"
          }
        },
        "confidential": {
          "confidential_details": {
            "confidential_list": "Confidential list",
            "date_placeholder": "DD/MM/YYYY",
            "date_and_time_of_creation": "(Date & Time of creation of the permanent insiders section)",
            "dt_of_last_update": "(Date & Time of the last update)",
            "a_brief_description_of_the_confidential_information": "A Brief Description of the Confidential Information",
            "confidential_list_long_description": "Confidential List Long Description",
            "add_new_person": "Add New Person",
            "delete": "Delete",
            "this_confidential_list_is_empty": "This Confidential List is empty. Please add at least one person to it!",
            "export_confidential_list": "Export Confidential List",
            "convert_to_a_deal_specific_insider_list": "Convert to a Deal-Specific Insider List",
            "name": "Name",
            "position": "Position",
            "email": "E-mail",
            "edit": "Edit",
            "disable_editing": "Disable Editing"
          },
          "confidential_list": {
            "closed_confidential_list": "Closed Confidential List",
            "confidential_list": "Confidential list",
            "create_new_confidential_list": "Create New Confidential List",
            "download": "Download",
            "details": "Details",
            "project_name": "Project Name",
            "date_and_time_of_creation": "Date and Time of Creation",
            "number_of_people": "Number of People",
            "short_name_of_information": "Short Name of Information",
            "dt_placeholder": "dd-mm-yyyy; hh:mm"
          },
          "new_confidential_form": {
            "confidential_list": "Confidential list",
            "project_name": "Project Name",
            "description_of_the_sensitive_information": "Description of the Sensitive Information",
            "current_date_and_time": "Current Date & Time",
            "it_can_be_modified": "(it can be modified)",
            "save": "Save",
            "cancel": "Cancel"
          }
        },
        "current_insider": {
          "list_of_transaction_specifi_insiders": {
            "closed_insider_lists": "Closed insider lists",
            "current_insider_lists": "Current insider lists",
            "search": "Search",
            "download": "Download",
            "details": "Details",
            "inside_information": "Inside Information",
            "project_name": "Project Name",
            "time_of_creation": "Time of Creation",
            "number_of_persons_included": "Number of Persons Included",
            "date_of_closure": "Date of Closure",
            "short_name_of_insider_information": "Short Name of Insider Information",
            "dt_placeholder": "dd-mm-yyyy; hh:mm",
            "number_of_people": "Number of People"
          },
          "specific_insider_details": {
            "deal_specific_insider_list": "Deal-Specific Insider List",
            "insider_list": "Insider list",
            "notifications_and_acknowledgements": "Notifications and Acknowledgments"
          }
        },
        "data_room": {
          "data_room_details": {
            "market_sounding_data_room": "Market Sounding Data Room - { dataroom }",
            "non_market_sounding_data_room": "Non-Market Sounding Data Room - { dataroom }",
            "uploaded_files": "Uploaded Files",
            "people_with_access": "People with Access"
          },
          "data_rooms": {
            "create_a_new_data_room": "Create a New Data Room",
            "market_sounding_data_room": "Market Sounding Data Room",
            "non_market_sounding_data_room": "Non-Market Sounding Data Room"
          }
        },
        "pdmr_pca": {
          "pca": {
            "name_and_email_address_of_the_person_discharging": "Name and e-mail address of the person discharging managerial responsibilities (PDMR) with whom you are closely associated.",
            "pdmr_name": "PDRM Name",
            "pdmr_email_address": "PDMR Email Address",
            "the_data_of_persons_closely_associated": "The data of persons closely associated (PCA) with the PDMR.",
            "pca_name": "PCA Name",
            "pca_email_address": "PCA Email Address",
            "new_transaction": "New Transactions",
            "download_application": "Download Application",
            "market_sounding_data_room": "Market Sounding Data Room",
            "data_room_name": "Data Room Name",
            "non_market_sounding_data_room": "Non-Market Sounding Data Room",
            "transaction_details": "Transaction Details",
            "notification_date": "Notification Date",
            "basic_transaction_details": "Basic Transaction Details"
          },
          "pdmr": {
            "pdmr_information": "PDMR Information",
            "name": "Name",
            "position_at_client": "Position at Client",
            "email_address": "Email Address",
            "phone_number": "Phone Number",
            "id_number": "ID Number",
            "place_of_birth": "Place of Birth",
            "date_of_birth": "Date of Birth",
            "time_of_inclusion": "Date of Inclusion",
            "modify": "Modify",
            "discard": "Discard",
            "save": "Save",
            "add_a_new_pca": "Add a New PCA",
            "download_all_notifications": "Download All Notifications",
            "pca_name": "PCA Name",
            "pca_email_address": "PCA Email Address",
            "reported_transactions": "Reported Transactions",
            "notify_new_transaction": "Notify New Transaction",
            "download_application": "Download Application",
            "periods_covered_by_the_trade_ban": "Periods Covered by The Trade Ban",
            "requests_on_trading_ban_exemption": "Requests on Trading Ban Exemption",
            "new_application": "New Application",
            "download": "Download",
            "insider_list": "Insider list",
            "market_sounding_data_room": "Market Sounding Data Room",
            "non_market_sounding_data_room": "Non-Market Sounding Data Room",
            "data_room_name": "Data Room Name",
            "transaction_details": "Transaction Details",
            "notification_date": "Notification Date",
            "request_id": "Request ID",
            "date": "Date",
            "approved_rejected": "Approved/Rejected"
          },
          "pdmr_list": {
            "pdmr_pca_list": "PDMR / PCA List",
            "notifications": "Notifications"
          },
          "published_reports": {
            "unpublished_pdmr_pca_reports": "Unpublished PDMR / PCA reports",
            "search": "Search",
            "provide_publishing_information": "Provide Publishing Information",
            "published_pdmr_pca_reports": "Published PDMR / PCA reports",
            "posted_link": "Posted Link",
            "name_of_applicant": "Name of Applicant",
            "time_of_notification": "Time of Notification",
            "pdmr_pca": "PDMR / PCA",
            "view_form": "View Form",
            "dt_placeholder": "yyyy.mm.dd hh:mm"
          },
          "report_transaction_form": {
            "name": "Name",
            "email": "E-mail",
            "position": "Position",
            "phone_number": "Phone Number",
            "this_form_is_required_for_disclosure": "This form is required for disclosure of transactions under Article 19 of Regulation (EU) No 596/2014 of the European Parliament and of the Council of 16 April 2014 on market abuse (Market Abuse Regulation)",
            "details_of_the_person_discharging": "1. Details of the person discharging managerial responsibilities/person closely associated",
            "natural_person": "Natural Person",
            "first_name": "First Name",
            "last_name": "Last Name",
            "legal_person": "Legal Person",
            "full_name": "Full Name",
            "modify": "Modify",
            "reason_for_the_notification": "2. Reason for the notification",
            "position_status": "Position/Status",
            "initial_notification": "Initial Notification",
            "amendment_to_prior_notification": "Amendment to Prior Notifications",
            "description": "Description",
            "details_of_the_issuer": "3. Details of the issuer, emission allowance market participant, auction platform, auctioneer or auction monitor",
            "full_name_of_the_entity": "FUll Name of the Entity",
            "lei_legal_entity_identifier": "LEI / Legal Entity Identifier",
            "details_of_the_transaction": "4. Details of the transaction(s): section to be repeated for (i) each type of instrument; (ii) each type of transaction; (iii) each date; and (iv) each place where transactions have been conducted",
            "details_of_the_transaction_section": "4.{idx}. Details of the transaction(s): section to be repeated for (i) each type of instrument; (ii) each type of transaction; (iii) each date; and (iv) each place where transactions have been conducted",
            "description_of_the_finincial_instrument": "Description of the financial instrument, type of instrument",
            "identification_code": "Identification Code",
            "nature_of_the_transaction": "Nature of the transaction",
            "description_of_the_transaction": "Description of the transaction type using, where applicable, the type of transaction identified in Article 10 of the Commission Delegated Regulation (EU) 2016/5221 adopted under Article 19(14) of Regulation (EU) No 596/2014 or a specific example set out in Article 19(7) of Regulation (EU) No 596/2014. Pursuant to Article 19(6)(e) of Regulation (EU) No 596/2014, it shall be indicated whether the transaction is linked to the exercise of a share option programme.",
            "prices_and_volumes": "Price(s) and Volume(s)",
            "aggregated_volume_and_price": "Aggregated Volume & Price",
            "time_of_the_transaction": "Time of the Transaction",
            "transaction_date_and_time": "Transaction Date & Time",
            "place_of_the_transaction": "Place of The Transaction",
            "name_and_code_to_identify_the_mifid": "Name and code to identify the MiFID trading venue, the systematic internaliser or the organised trading platform outside of the Union where the transaction was executed as defined under Commission Delegated Regulation supplementing Regulation (EU) No 600/2014 of the European Parliament and of the Council with regard to regulatory technical standards for the reporting of transactions to competent authorities adopted under Article 26 of Regulation (EU) No 600/2014, or if the transaction was not executed on any of the above mentioned venues, please mention 'outside a trading venue'.",
            "additional_information": "Additional Information",
            "submit_form": "Submit Form",
            "where_more_then_one_transaction": "Where more than one transaction of the same nature (purchases, sales, lendings, borrows, …) on the same financial instrument or emission allowance are executed on the same day and on the same place of transaction, prices and volumes of these transactions shall be reported in this field, in a two columns form as presented above, inserting as many lines as needed.",
            "new_detail": "Add new detail"
          }
        },
        "data_room_control_panel": {
          "market_sounding_data_room": "Market Sounding Data Room",
          "data_room_name": "Data Room Name",
          "non_market_sounding_data_room": "Non-Market Sounding Data Room",
          "this_room_contains_insider_information": "This room contains insider information"
        },
        "insider_list_control_panel": {
          "insider_list": "Insider list",
          "market_sounding_data_room": "Market Sounding Data Room",
          "non_market_sounding_data_room": "Non-Market Sounding Data Room",
          "data_room_name": "Data Room Name"
        },
        "packages": {
          "subscribed_package_and_additional_services": "Subscribed Package and Additional Services",
          "other_package_offers": "Other Package Offers"
        },
        "period_ban": {
          "fixing_the_period_covered_by_the_trading_ban": "Fixing the period covered by the trading ban",
          "start_date_of_publication_of_half_yearly": "Start date of publication of half-yearly financial reports:",
          "end_date_of_publication_of_half_yearly": "End date of publication of half-yearly financial reports:",
          "start_date_of_publication_of_annual": "Start date of publication of annual financial reports:",
          "end_date_of_publication_of_annual": "End date of publication of annual financial reports:",
          "save": "Save",
          "send_emails_automatically": "Send emails automatically",
          "days_before_the_start_of_closed_period": "day(s) before the start of closed period.",
          "list_of_persons_to_be_notified": "List of persons to be notified",
          "date_sent": "Date Sent",
          "previous_notifications": "Previous Notifications",
          "requests_on_trade_ban_excemptions": "Requests on Trading Ban Exemption",
          "reject": "Reject",
          "accept": "Accept",
          "are_you_sure_you_want_to_accept_the_excemption": "Are you sure you want to accept the exemption?",
          "are_you_sure_you_want_to_reject_the_excemption": "Are you sure you want to reject the exemption?",
          "back": "Back",
          "pdmr_name": "PDRM Name",
          "email_address": "Email Address",
          "time_of_notification": "Time of Notification",
          "automatic_email_notifications": "Automatic Email Notifications",
          "name": "Name",
          "request_link": "Request Link",
          "dt_placeholder": "yyyy.mm.dd hh:mm",
          "successfully_updated_period": "Successfully updated period!",
          "ban_period_successfully_updated": "Ban period successfully updated!",
          "successfully_updated_notification_state": "Successfully updated notification state!",
          "successfully_accepted_excemption_request": "Successfully accepted exemption request!",
          "successfully_rejected_excemption_request": "Successfully rejected exemption request!",
          "there_is_no_notification": "There is no notification to show"
        },
        "permanent_insider_list": {
          "permanent_insider_list": "Permanent Insider List",
          "insider": "insider",
          "notifications_and_acknowledgements": "Notifications and Acknowledgments"
        },
        "roles_select_page": {
          "select_role": "Select Role",
          "please_select_role": "Please select role",
          "investor_contact": "Investor Contact",
          "admin": "Admin",
          "pdmr": "PDRM",
          "pca": "PCA",
          "person_on_deal_specific_insider_list": "Person on Deal-Specific Insider List",
          "person_invited_only_to_data_rooms": "Person invited only to data room(s)"
        },
        "settings": {
          "company_name": "Company Name",
          "company_headquarters": "Company Headquarters",
          "automatically_log_off_users_after": "Automatically log off users after",
          "input": "Input",
          "minutes_of_inactivity": "minutes of inactivity.",
          "change_data": "Change Data",
          "change_password": "Change Password",
          "client_decrypt_request": "Client Decrypt Request",
          "login_history": "Login history",
          "permanently_delete_profile": "Permanently Delete Profile",
          "delete_my_account": "Delete My Account",
          "site_documents": "Site documents",
          "document_title": "Document Title",
          "document_type": "Document Type",
          "document_content": "Document Content",
          "date": "Date",
          "edit_document": "Edit document",
          "from_date": "From Date",
          "document_title_required": "Document title is required",
          "from_date_required": "From date is required",
          "document_content_required": "Document content is required",
          "create_document": "Create document",
          "delete_document": "Delete document"
        },
        "subscriptions": {
          "subscribed_package": "Subscribed Package",
          "subscribed_package_name": "Subscribed Package Name",
          "download_content": "Download Content",
          "change_subscription": "Change Subscription",
          "my_accounts": "My Accounts",
          "seach_accounts_by_number": "Search accounts by Number",
          "account_number": "Account Number",
          "date_of_issue": "Date of Issue",
          "date_of_completion": "Date of Completion",
          "download_request": "Download Request",
          "download_invoice": "Download Invoice"
        },
        "upload_application": {
          "upload_application": "Upload Application",
          "file_name": "File Name",
          "proceed": "Proceed"
        },
        "declaration_of_recognition_share": {
          "document_and_information_disclosure": "I acknowledge that the documents and information shared in the data room will be disclosed in the context of market sounding under Article 11 of Regulation (EU) No 596/2014 on market abuse.",
          "communication": "I confirm that the Client is communicating with the person entrusted by the potential investor to receive the market sounding.",
          "judge_for_self": "I acknowledge that if I agree to receive the market sounding, I will receive information that the Client considers to be inside information. I acknowledge that, in each case, I must judge for myself whether I am in possession of inside information and at what point in time the information in my possession ceases to be inside information.",
          "cease_inside_info": "I understand that if the inside information provided ceases to be inside information, I will be informed of this fact by e-mail.",
          "financial_instruments": "I acknowledge that I am prohibited from using the inside information provided, or attempting to use that information, by acquiring or disposing of, for my own account or for the account of a third party, directly or indirectly, financial instruments relating to that information.",
          "amend_cancel": "I acknowledge that I am prohibited from using the inside information provided, or attempting to use that information, by cancelling or amending an order which has already been placed concerning a financial instrument to which the information relates.",
          "confidentiality_obl": "I understand that by agreeing to receive inside information I am obliged to keep the inside information confidential.",
          "info_receive": "I expressly consent to receive inside information in the course of market sounding.",
          "data_room_separation": "I acknowledge that the data room contains all information provided for the purpose of market sounding, separately identifying the information that is considered by the Client to be inside information.",
          "privacy_policy": "I have read the privacy notice and I accept the privacy policy { link }"
        },
        "declaration_of_recognition_no_share": {
          "document_and_information_disclosure": "I acknowledge that the documents and information shared in the data room will be disclosed in the context of market sounding under Article 11 of Regulation (EU) No 596/2014 on market abuse.",
          "communication": "I confirm that the Client is communicating with the person entrusted by the potential investor to receive the market sounding.",
          "not_inside_information": "I acknowledge that if I agree to receive the market sounding, I will receive information that the Client considers not to be inside information. I acknowledge that, in each case, I must judge for myself whether I am in possession of inside information and at what point in time the information in my possession ceases to be inside information.",
          "info_receive": "I expressly consent to receive inside information in the course of market sounding.",
          "data_room_all": "I acknowledge that the data room contains all information provided for the purpose of market sounding.",
          "privacy_policy": "I have read the privacy notice and I accept the privacy policy { link }"
        },
        "insider_first_login": {
          "legal_and_regulatory_duties": "I expressly acknowledge that I have been informed by the Client of the legal and regulatory duties entailed with inclusion on the insider list and of the sanctions applicable to insider dealing and unlawful disclosure of inside information.",
          "retain_insider_list": "I acknowledge that the Client is obliged to retain the insider list for at least five years after it is drawn up or updated and to submit it to the Hungarian National Bank as soon as possible upon request.",
          "privacy_policy": "I have read the privacy notice and I accept the privacy policy { link }"
        },
        "normal_first_login": {
          "privacy_policy": "I have read the privacy notice and I accept the privacy policy { link }"
        }
      }
    },
    "aside": {
      "classification_and_delay_of_inside_info": "Classification and Delay of Inside Info.",
      "insider_list": {
        "title": "Insider List",
        "submenu": {
          "permanent_insider_list": "Permanent Insider List",
          "transaction-specific_insiders_list": "Transaction-Specific Insiders List",
          "confidential_list": "Confidential List"
        }
      },
      "management_transactions": {
        "title": "Management Transactions",
        "submenu": {
          "record-keeping": "Record-keeping",
          "transaction_reporting_for_executives_and_close_associates": "Transaction reporting for executives and close associates",
          "trading_ban_period": "Trading Ban Period"
        }
      },
      "transfer_of_inside_info": "Transfer of Inside Info.",
      "transaction_form": "Transaction form",
      "dashboard": "Dashboard"
    },
    "dropdown": {
      "settings": "Settings",
      "pdmr": "PDMR",
      "pca": "PCA",
      "dashboard": "Dashboard",
      "my_subscription": "My Subscription",
      "era_form_filler": "ERA Form Filler",
      "billing_data": "Billing Data",
      "billing": "Billing",
      "change_password": "Change password",
      "login_history": "Login history"
    },
    "util": {
      "decrypt_request": "Decrypt Request",
      "request_sent": "Request sent",
      "up_to_date": "Up to date",
      "loading": "Loading",
      "save_selected_representatives": "Save selected representatives",
      "items_per_page": "Items per page",
      "page": "Page",
      "board_member": "Board member",
      "representative": "representative",
      "current_share_requests": "You have 1 share request pending | You have {count} share requests pending",
      "handle_share_requests": "You have 1 share new request. Decrypting data... | You have {count} new share requests. Decrypting data..."
    }
  },
  "header": {
    "logout": "Logout",
    "log_in": "Log in",
    "create_master_key": "Create Master Key",
    "master_key_warning": "WARNING, losing the master key may result in the loss of data stored in the system!",
    "edit_master_key": "Edit Master Key",
    "billing_data": "Billing Data",
    "settings": "Settings",
    "enter_your_master_password": "Enter your master key!",
    "enter_your_master_password_again": "Enter your master key again!",
    "master_password": "Master key",
    "wrong_master_password": "Wrong master key",
    "save": "Save",
    "the_password_must_contain_at_least_one_uppercase_letter_and_one_lowercase_letter": "The master key must contain at least one uppercase letter and one lowercase letter.",
    "the_password_must_contain_at_least_one_symbol": "The master key must contain at least one symbol.",
    "the_password_must_contain_at_least_one_number": "The master key must contain at least one number.",
    "the_confirm_password_must_match_the_password": "The confirm master key must match the master key.",
    "discard": "Discard",
    "old_password": "Old Master Key",
    "password": "Master Key",
    "confirm_password": "Confirm Master Key",
    "enter_your_email": "Enter your email",
    "email_address": "Email Address",
    "next": "Next",
    "enter_your_master_password_description": "If you would like to reset your master key, please contact your system administrator.",
    "this_is_not_your_email": "This is not your email",
    "are_you_sure_you_want_to_log_out": "Are you sure you want to log out?",
    "yes": "Yes",
    "no": "No"
  },
  "inclusion_emails": {
    "select_language": "Select Email language",
    "english": "English",
    "hungarian": "Hungarian"
  },
  "info-requalification": {
    "requalification_of_information": "Requalification of Information",
    "project_name": "Project Name",
    "please_indicate_the_name_of_the_project": "Please indicate the name of the project (e.g. merger, project MABU, etc.). It is important that this field cannot contain any inside information.",
    "description_of_the_information": "Description of the Information to be Qualified",
    "current_date_and_time": "Current Date & Time",
    "it_can_be_modified": "(it can be modified)",
    "uploaded_files": "Uploaded Files",
    "upload_file": "Upload File",
    "attention_the_selected_files_are_uploading": " Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
    "discard": "Discard",
    "save": "Save",
    "the_conditions_of_delaying": "The conditions of delaying the disclosure of inside information as prescribed by Article 17(4) of MAR are not met. Please disclose the inside information as soon as possible!",
    "back": "Back",
    "publish": "Publish",
    "the_recorded_delay_data_will_not_be_clumped": "The recorded delay data will not be clumped, but insider information will be saved!",
    "proceed": "Proceed",
    "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
    "ok": "Ok",
    "files_uploaded_successfully": "Files uploaded successfully!",
    "date_of_qualification": "Date of Qualification",
    "what_do_you_want_to_do_with_the_information": "What do you want to do with the information?",
    "delay": "Delay",
    "immediate_publication": "Immediate Publication",
    "do_you_want_to_save_these_changes": "Do you want to save these changes?",
    "do_you_want_to_reclassify_the_information": "Do you want to reclassify the information?",
    "yes": "Yes",
    "no": "No",
    "qualify_information": "Qualify Information",
    "reclassification": "Reclassification",
    "SME_agree_to_to_create_insider_information": "Would you like to create a transaction-specific insider list in relation to this information?",
    "intermediate_step_question": "Is the information to be assessed considered an intermediate step in a protracted process under MAR?",
    "intermediate_step_mar_notice": "In case of an “intermediate step in a protracted process” under MAR, only the final circumstance or final event must be disclosed to the public as soon as possible after it has occurred.",
    "continue": "Continue"
  },
  "insider-list": {
    "name_of_insider": "Name of Insider",
    "email_address": "E-mail Address",
    "date_placeholder": "DD/MM/YYYY",
    "date_and_time_of_creation": "Date and Time of Creation",
    "delete": "Delete",
    "discard": "Discard",
    "back": "Back",
    "do_you_want_to_delete_this_insider": "Do you want to delete this insider?",
    "notification_emails": "Notification Email(s)",
    "resend_notification": "Resend notification email",
    "acknowledgements": "Acknowledgements",
    "download_all_acknowledgements": "Download All Acknowledgements",
    "download_all_notification_emails": "Download All Notification Emails",
    "dt_of_creation_of_permanent_insider_section": "Date & Time of creation of the permanent insiders section",
    "dt_of_last_update": "Date & Time of the last update",
    "date_of_transmission_to_competent_authority": "Date of transmission to the competent authority",
    "export_the_permanent_insider_list": "Export the Permanent Insider List",
    "first_name": "First Name",
    "surname": "Surname",
    "birth_surname": "Birth Surname",
    "professional_telephone_number": "Professional Telephone Number",
    "company_name": "Company Name",
    "company_address": "Company Address",
    "function_and_reason_for_being_insider": "Function and reason for being insider",
    "function_and_reason_for_being_insider_title": "Text describing the role, function and reason for inclusion in this list",
    "function_and_reason_for_being_insider_title_reform": "Text describing role, function and reason for being in this section, including the company name and address in the case of third-party service providers.",
    "function_and_reason_for_being_insider_title_reform_sme": "Text describing role, function and reason for being in this list, including the company name and address in the case of third-party service providers.",
    "function_and_reason_for_being_insider_placeholder": "Function and Reason for being Insider",
    "first_name_tooltip": "In the case of third-party service providers, the first name(s) of the natural person acting as a contact person for that third-party service provider.",
    "surname_tooltip": "In the case of third-party service providers, the surname(s) of the natural person acting as a contact person for that third-party service provider.",
    "included": "Included",
    "dt_of_persons_inclusion": "The date and time of the person's inclusion in the permanent insiders section (yyyy-mm-dd, hh:mm UTC).",
    "dt_of_persons_inclusion_reform": "The date and time when the insider obtained access to all inside information at all times.",
    "dt_of_persons_inclusion_reform_sme": "The date and time when the insider obtained regular access to inside information.",
    "birthdate": "Date of birth",
    "national_id_card_number": "National Identification Number",
    "personal_telephone_number": "Personal Telephone Number",
    "personal_full_home_address": "Personal Full Home Address",
    "personal_full_home_address_title": "Country, postcode, city, street, house number",
    "save_data": "Save",
    "name_of_the_insider": "Name of the Insider",
    "data_completeness": "Data Completeness",
    "last_login": "Last Login",
    "mar_18_notifications": "MAR 18(2) Notifications",
    "mar_18_acknowledgements": "MAR 18(2) Acknowledgements",
    "not_logged_in_yet": "Not logged in yet",
    "select_version": "Choose version...",
    "permanent_insider_list": "Permanent Insider List",
    "insider": "insider",
    "notifications_and_acknowledgements": "Notifications and Acknowledgments",
    "add_new_person": "Add New Person",
    "edit": "Edit",
    "disable_editing": "Disable Editing",
    "email": "Email",
    "last_name": "Last Name",
    "birth_last_name": "Birth Last Name",
    "obtained": "Obtained",
    "obtained_info": "Obtained info",
    "dt_of_the_entry": "Date and time of the entry of the person into the deal-specific insider section (yyyy-mm-dd, hh: dd UTC)",
    "reason_for_listing": "Function and reason for being insider",
    "add_the_person_as_central_contract_point": "Will the person be added as a central contract point?",
    "add_the_person_as_central_contract_point_info": "Info",
    "yes": "Yes",
    "no": "No",
    "notify_the_insider": "Notify the insider about the inclusion in the insider list, the legal and regulatory duties entailed, and the sanctions applicable to insider dealing and unlawful disclosure of inside information as per Article 18(2) of MAR.",
    "confirm": "Confirm",
    "download": "Download",
    "date_sent": "Date Sent",
    "subject": "Subject",
    "body": "Body",
    "inclusion_email_attachments": "Inclusion Email Attachments",
    "uploaded_files": "Uploaded Files",
    "upload_file": "Upload File",
    "send": "Send",
    "export": "Export",
    "phone_number": "Phone Number",
    "central_contact_person": "Central contact person",
    "accepted_at": "Accepted at",
    "ceased": "Ceased",
    "national_id_card_number_tooltip": "National ID card / passport number.",
    "national_id_card_number_tooltip_reform": "ID card or passport number.",
    "blocked_at_tooltip_reform": "The date and time when the insider ceased to have access to all inside information at all times.",
    "blocked_at_tooltip_reform_sme": "The date and time when the insider ceased to have regular access to inside information.",
    "permanently_delete": "Permanently Delete",
    "previous_permanent_insiders": "Previous permanent insiders",
    "restore": "Restore",
    "send_notification_to": "Send Notification to",
    "notification_sent": "Notification Sent",
    "out_of": "Out of",
    "users": "Users",
    "send_email_to": "Send e-mail to:",
    "cancel": "Cancel",
    "statements": "Statements",
    "delete_date": "Delete Date",
    "no_decrypted_data": "Decryption is in progress. Please contact your investor relations representative if necessary.",
    "no_statement_file": "No statement file",
    "email_autofill_search_hint": "(user search suggestions from 5+ characters)",
    "bulk_add_persons": "Bulk add",
    "bulk_add_modal_title": "Add multiple people to the permanent insider list",
    "bulk_add_modal_title_case_insider_list": "Add multiple people to this insider list",
    "bulk_notification_tooltip_case_insider_list": "When enabled, this person will be included in the next step where you can send the insider list inclusion notification email after users are added.",
    "bulk_add_remove_row": "Remove",
    "bulk_add_add_row": "Add another row",
    "bulk_add_submit": "Add all",
    "bulk_do_not_close_warning": "Do not close this page, reload, or navigate away until the process has finished.",
    "bulk_add_progress_created": "Created {current} / {total}",
    "bulk_add_progress_remaining": "{n} remaining",
    "bulk_results_title": "Results",
    "bulk_col_email": "Email",
    "bulk_col_name": "Name",
    "bulk_col_status": "Status",
    "bulk_col_reason": "Reason",
    "bulk_col_error_detail": "Details",
    "bulk_col_actions": "Remove",
    "bulk_col_notification": "Notification",
    "bulk_notification_tooltip": "When enabled, this person will be included in the next step where you can send the permanent insider list inclusion notification email after users are added.",
    "bulk_status_success": "Success",
    "bulk_status_failed": "Failed",
    "bulk_error_duplicate_list": "User already on this list or duplicate",
    "bulk_error_permanent_list": "User is on the permanent insider list",
    "bulk_error_server": "Server error",
    "bulk_error_generic": "Request failed",
    "bulk_continue_to_email": "Continue to notification emails",
    "bulk_close": "Close",
    "bulk_recipients_title": "Recipients (successful adds)",
    "bulk_send_all": "Send all notifications",
    "bulk_email_progress_sent": "Sent {current} / {total}",
    "bulk_email_results_title": "Notification send results",
    "bulk_form_error_min_rows": "Select at least one user from the search results.",
    "bulk_form_error_max_rows": "You can add a maximum of {max} users at once.",
    "bulk_form_error_must_select_email": "Every row must have a user selected from the directory search (pick from the list). Remove rows you do not need, or complete each row. Free-text email is not allowed.",
    "bulk_form_error_duplicate_email": "Remove duplicate emails in the list.",
    "bulk_form_error_incomplete_row": "Each row must have a user selected from the list (no free-text email).",
    "bulk_email_search_min_chars_hint": "Type at least 5 characters to search.",
    "bulk_row_error_select_email": "Select a user from the directory list.",
    "bulk_row_error_duplicate_email": "This email is used more than once.",
    "bulk_row_error_invalid_email": "Enter a valid email address.",
    "bulk_row_error_first_name": "First name is required.",
    "bulk_row_error_last_name": "Last name is required.",
    "bulk_inclusion_send_email": "Send this notification email",
    "bulk_inclusion_cancel_confirm": "Discard all edits and close? Notifications will not be sent."
  },
  "insider-template": {
    "data_on_inside_information": "Data on inside information",
    "brief_description_of_the_information": "Brief description of the information",
    "detailed_description_of_the_information": "Detailed description of the information",
    "creation_information": "Creation information",
    "date_and_time_of_creation": "Date and time of creation",
    "name_of_the_decision_maker": "Name of the decision maker",
    "conceptual_elements_of_inside_information": "Conceptual elements of inside information",
    "has_the_condition_been_met": "Has the condition been met?",
    "yes": "Yes",
    "no": "No",
    "has_the_information_been_disclosed_via_market_sounding": "Has the information been disclosed via market sounding?",
    "data_on_the_delay_of_inside_information": "Data on the delay of inside information",
    "date_and_time_of_the_delay": "Date and time of the delay",
    "name_of_the_person_who_delayed": "Name of the person who delayed",
    "conditions_for_delay": "Conditions for delay",
    "data_relating_to_the_cessation_of_inside_information": "Data relating to the cessation of inside information",
    "reason_for_cessation_of_inside_information": "Reason for cessation of inside information",
    "date_and_time_of_cessation_of_inside_information": "Date and time of cessation of inside information",
    "publication_details": "Publication details",
    "link": "link",
    "k_number": "K-number",
    "publication_date": "Publication date",
    "ceased_option": "Ceased",
    "published_option": "Published",
    "data_concerning_the_confidential_information": "Data concerning the confidential information",
    "delay_type": "Delay type",
    "intermediate_step": "Intermediate step"
  },
  "login-code-verification": {
    "test": ""
  },
  "login-email-notification": {
    "login_to_mabureg": "Login to MABUREG",
    "your_one_time_use_link_has_been_sent": "Your one time use link has been sent to your email address! Please check your emails, and use the link to log-in."
  },
  "login-password": {
    "enter_your_password_below": "Enter your password below",
    "password": "Password",
    "forgot_password": "Forgot password?",
    "log_in": "Log in",
    "old_password": "Old password",
    "login_to_mabureg": "Login to MABUREG"
  },
  "login": {
    "login_to_mabureg": "Login to MABUREG",
    "email_address": "Email address",
    "phone_number": "Phone number",
    "password": "Password",
    "enter_your_email_below": "Enter your email below",
    "email_address_phone_number": "Email Address / Phone Number",
    "log_in": "Log in",
    "forgot_password": "Forgot password?",
    "login_credentials": "Login Credentials",
    "login_credentials_subtitle": "Your login credentials are below. Please keep them safe and do not share them with anyone.",
    "invalid_or_missing_link": "Invalid or missing link.",
    "master_credentials_title": "Applicant master key",
    "master_password_label": "Master key",
    "reveal": "Reveal",
    "hide": "Hide",
    "copy": "Copy",
    "copied_to_clipboard": "Copied to clipboard",
    "proceed_to_login": "Proceed to login",
    "new_client": "Create new client",
    "register": "Register",
    "uid_info": "Leave blank if you don't know your UID",
    "sms_code": "E-mail verification code"
  },
  "main": {
    "clients": "Clients",
    "search_by_name": "Search by name",
    "name": "Name",
    "invoice": "Invoice",
    "contracts": "Contracts",
    "subscriptions": "Subscriptions",
    "view_client": "View client",
    "automated_emails": "Automated emails",
    "folder_name": "Folder name",
    "open_folder": "Open folder",
    "email_templates": "Email templates",
    "template_name": "Template name",
    "edit_template": "Edit template",
    "category": "Category",
    "type": "Type",
    "template_name_en": "Template Name (EN)",
    "template_name_hu": "Template Name (HU)",
    "subject_en": "Subject (EN)",
    "subject_hu": "Subject (HU)",
    "body_en": "Body (EN)",
    "body_hu": "Body (HU)",
    "category_required": "Category is required",
    "type_required": "Type is required",
    "template_name_hu_required": "Template Name (HU) is required",
    "template_name_en_required": "Template Name (EN) is required",
    "subject_hu_required": "Subject (HU) is required",
    "subject_en_required": "Subject (EN) is required",
    "body_hu_required": "Body (HU) is required",
    "body_en_required": "Body (EN) is required",
    "template_saved_successfully": "Template saved successfully",
    "save": "Save",
    "cancel": "Cancel",
    "template_updated": "Template updated successfully",
    "add_attachments": "Add attachments",
    "template_not_up_to_date_with_the_admin": "Template is not up to date with the admin",
    "check_admin_template": "Check admin template",
    "admin_template": "Admin template",
    "data_decryption_request_sent": "Due to data encryption, the first login is only possible after the administrator has logged in.",
    "please_wait_for_the_admin_the_decrypt_your_data": "You do not need to do anything further, the system will automatically allow you to log in as soon as this happens. Please come back later and refresh the page.",
    "add_attachment": "Add attachment",
    "hu_attachments": "Attachments (HU)",
    "en_attachments": "Attachments (EN)",
    "compliance_statements": "Compliance statements",
    "statement_key": "Key",
    "statement_model": "Model",
    "statement_name_en": "Title (EN)",
    "statement_name_hu": "Title (HU)",
    "statement_name_en_required": "Title (EN) is required",
    "statement_name_hu_required": "Title (HU) is required",
    "edit_statement": "Edit statement",
    "statement_points": "Statement points",
    "statement_point_label": "Point {n}",
    "statement_point_body_hu": "Body (HU)",
    "statement_point_body_en": "Body (EN)",
    "statement_is_checkbox": "Show as checkbox",
    "statement_point_required": "Each statement point must have content in both Hungarian and English",
    "statement_point_body_hu_required": "Hungarian content is required for this point",
    "statement_point_body_en_required": "English content is required for this point",
    "statement_points_have_errors": "Please correct the errors in the statement points above.",
    "add_statement_point": "Add point",
    "statement_point_remove": "Remove point",
    "copy_variable_name": "Copy variable name",
    "copy_variable_hint": "Paste these placeholders into the editor where dynamic text should appear.",
    "copy": "Copy",
    "variable_copied": "Variable copied to clipboard",
    "copy_failed": "Could not copy to clipboard",
    "statement_updated": "Statement updated successfully"
  },
  "market-data-room-details": {
    "market_sounding_data_room": "Market Sounding Data Room - { dataroom }",
    "non_market_sounding_data_room": "Non-Market Sounding Data Room - { dataroom }",
    "uploaded_files": "Uploaded Files",
    "people_with_access": "People with Access",
    "upload_new_documents": "Upload New Document(s)",
    "delete": "Delete",
    "download": "Download",
    "download_document_list": "Download Document List",
    "download_all_files_zip": "Download All Files (.zip)",
    "file_name": "File Name",
    "time_of_upload": "Time of Upload",
    "folder_name": "Folder Name",
    "open_folder": "Open Folder",
    "create_new_folder": "Create New Folder",
    "create": "Create",
    "discard": "Discard",
    "rename": "Rename",
    "this_file_contains_inside_information": "This file contains inside information.",
    "select_insider_information_from_the_list": "Select Insider Information from the List!",
    "insider_information_related_to_the_file": "Insider information related to the file.",
    "upload_file": "Upload File",
    "yes": "Yes",
    "no": "No",
    "please_select_the_files": "Please select the files that contain inside information!",
    "upload_files": "Upload Files",
    "please_select_the_file_list": "Please check the file list before uploading!",
    "name": "Name",
    "email_address": "Email Address",
    "grant_access": "Grant Access",
    "take_away_access_from_everyone": "Take Away Access From Everyone",
    "take_away_access": "Take Away Access",
    "email_notifications": "E-mail Notification(s)",
    "acknowledgement": "Acknowledgement",
    "download_list_of_people_with_access": "Download List of People with Access",
    "download_notification_emails_and_statements": "Download Notification Emails and Statements",
    "personal_data": "Personal Data",
    "notification_status": "Notification Status",
    "statement_of_consent_status": "Statement of Consent Status",
    "termination_of_access": "Termination of access",
    "telephone_number": "Telephone Number",
    "dt_placeholder": "dd-mm-yyyy; hh:mm",
    "the_person_to_be_added": "The person to be added to this data room is not yet on the insider list in respect of the following inside information",
    "name_of_inside_information": "Name of Inside Information",
    "notification_and_insider_listing": "Notification & Insider Listing",
    "address": "Address",
    "subject": "Subject",
    "body": "Body",
    "email": "Email",
    "inclusion_email_attachments": "Attachments (These files can be downloaded and attached to the notification email)",
    "send": "Send",
    "first_name": "First Name",
    "last_name": "Last Name",
    "phone_number": "Phone Number"
  },
  "my-logins": {
    "time": "Time",
    "ip": "IP address",
    "device": "Device",
    "name": "Name",
    "email": "Email",
    "search_by_name_email": "Search by name or email",
    "others_logins": "Others logins",
    "my_logins": "My logins",
    "there_is_no_login": "There is no login on the given date"
  },
  "new-client": {
    "login_to_mabureg": "Login to MABUREG",
    "create_new_client": "Create new MABUREG client",
    "new_client_created_successfully": "New client created successfully",
    "this_is_your_account_uid": "This is your account UID:",
    "email_address": "Email address",
    "phone_number": "Phone number",
    "password": "Password",
    "confirm_password": "Confirm password",
    "register": "Register",
    "log_in": "Log in"
  },
  "new-confidential": {
    "confidential_list": "Confidential list",
    "project_name": "Project Name",
    "description_of_the_sensitive_information": "Description of the Sensitive Information",
    "current_date_and_time": "Current Date & Time",
    "it_can_be_modified": "(it can be modified)",
    "save": "Save",
    "cancel": "Cancel"
  },
  "new-contact": {
    "contact_details": "Contact Details",
    "clients_name": "Company name",
    "clients_address": "Company address",
    "clients_company_registration_number": "Company Registration Number",
    "investor_contacts_name": "Investor Contact's Name",
    "investor_contacts_position": "Investor Contact's Position",
    "investor_contacts_email_address": "Investor Contact's Email Address",
    "investor_contacts_phone_number": "Investor Contact's Phone Number",
    "subscribed_package": "Subscribed Package",
    "regulated_market": "Regulated Market",
    "sme": "SME",
    "advisory": "Advisory",
    "discard": "Discard",
    "save": "Save",
    "email_address": "Email Address",
    "tax_number": "Tax Number",
    "data_protection_officer": "Data Protection Officer",
    "next": "Next",
    "loading": "Loading",
    "save_selected_representatives": "Save selected representatives",
    "items_per_page": "Items per page",
    "page": "Page",
    "board_member": "Board member",
    "representative": "representative",
    "position_at_client": "Position at Client",
    "first_name": "First Name",
    "last_name": "Last Name",
    "phone_number": "Phone Number",
    "id_number": "ID Number",
    "place_of_birth": "Place of Birth",
    "date_of_birth": "Date of Birth",
    "date_of_inclusion": "Date of Inclusion",
    "send_a_mar_notification": "Send a MAR notification at the same time as recording",
    "city": "City",
    "zip_code": "Zip Code",
    "position": "Position",
    "lei_number": "LEI Number",
    "contact_person_address": "Contact person address",
    "contact_person_city": "Contact person city",
    "contact_person_zip_code": "Contact person zip code"
  },
  "new-info-qualifications": {
    "reclassify_the_information": "Reclassify The Information",
    "requalification_of_information": "Qualification of New Information",
    "project_name": "Project Name",
    "please_indicate_the_name_of_the_project": "Please indicate the name of the project (e.g. merger, project MABU, etc.). It is important that this field cannot contain any inside information.",
    "description_of_the_information": "Description of the Information to be Qualified",
    "current_date_and_time": "Current Date & Time",
    "it_can_be_modified": "(it can be modified)",
    "uploaded_files": "Uploaded Files",
    "upload_file": "Upload File",
    "attention_the_insider_information_is_being_created": "Attention! This insider information is being created, please do not close the window, or proceed anywhere!",
    "attention_the_selected_files_are_uploading": "Attention! The selected files are uploading to the server, please do not close the window, or proceed anywhere!",
    "discard": "Discard",
    "classify_information": "Classify The Information",
    "what_do_you_want_to_do_with_the_information": "What do you want to do with the information?",
    "delay": "Delay",
    "immediate_publication": "Immediate Publication",
    "this_information_does_not_qualify": "The confidential information has been created. Would you like to create a confidential list, so-called precautionary list, related to the information?",
    "before_this_information_does_not_qualify": "Based on the information provided, the information is not considered inside information. Are you sure you want to create confidential (and not inside) information?",
    "no": "No",
    "yes": "Yes",
    "attention_you_have_not_qualified": "Attention! You have not qualified all the options! Please fill out every necessary fields!",
    "ok": "Ok",
    "files_uploaded_successfully": "Files uploaded successfully!",
    "successfully_created": "Successfully created!",
    "edit_the_information": "Edit the information",
    "confirm_edit_the_information": "Confirm Edit the information",
    "do_you_want_to_Reclassify_the_information": "Do you want to Reclassify the information",
    "save_changes": "Save Changes",
    "qualify": "Qualify",
    "date_of_qualification": "Date of qualification",
    "intermediate_step": "Intermediate step",
    "intermediate_step_question": "Is the information to be assessed considered an intermediate step in a protracted process under MAR?",
    "intermediate_step_mar_notice": "In case of an “intermediate step in a protracted process” under MAR, only the final circumstance or final event must be disclosed to the public as soon as possible after it has occurred.",
    "continue": "Continue"
  },
  "new-password": {
    "test": ""
  },
  "non-market-data-room-details": {
    "market_sounding_data_room": "Market Sounding Data Room - { dataroom }",
    "non_market_sounding_data_room": "Non-Market Sounding Data Room - { dataroom }",
    "uploaded_files": "Uploaded Files",
    "people_with_access": "People with Access",
    "upload_new_documents": "Upload New Document(s)",
    "delete": "Delete",
    "download": "Download",
    "download_document_list": "Download Document List",
    "download_all_files_zip": "Download All Files (.zip)",
    "file_name": "File Name",
    "time_of_upload": "Time of Upload",
    "folder_name": "Folder Name",
    "open_folder": "Open Folder",
    "create_new_folder": "Create New Folder",
    "create": "Create",
    "discard": "Discard",
    "rename": "Rename",
    "this_file_contains_inside_information": "This file contains inside information.",
    "select_insider_information_from_the_list": "Select Insider Information from the List!",
    "insider_information_related_to_the_file": "Insider information related to the file.",
    "upload_file": "Upload File",
    "yes": "Yes",
    "no": "No",
    "please_select_the_files": "Please select the files that contain inside information!",
    "upload_files": "Upload Files",
    "please_select_the_file_list": "Please check the file list before uploading!",
    "name": "Name",
    "email_address": "Email Address",
    "grant_access": "Grant Access",
    "take_away_access_from_everyone": "Take Away Access From Everyone",
    "take_away_access": "Take Away Access",
    "email_notifications": "E-mail Notification(s)",
    "acknowledgement": "Acknowledgement",
    "download_list_of_people_with_access": "Download List of People with Access",
    "download_notification_emails_and_statements": "Download Notification Emails and Statements",
    "personal_data": "Personal Data",
    "notification_status": "Notification Status",
    "statement_of_consent_status": "Statement of Consent Status",
    "termination_of_access": "Termination of access",
    "telephone_number": "Telephone Number",
    "dt_placeholder": "dd-mm-yyyy; hh:mm",
    "the_person_to_be_added": "The person to be added to this data room is not yet on the insider list in respect of the following inside information",
    "name_of_inside_information": "Name of Inside Information",
    "notification_and_insider_listing": "Notification & Insider Listing",
    "address": "Address",
    "subject": "Subject",
    "body": "Body",
    "email": "Email",
    "inclusion_email_attachments": "Attachments (These files can be downloaded and attached to the notification email)",
    "send": "Send",
    "first_name": "First Name",
    "last_name": "Last Name",
    "phone_number": "Phone Number"
  },
  "packages": {
    "subscribed_package_and_additional_services": "Subscribed Package and Additional Services",
    "other_package_offers": "Other Package Offers",
    "request": "Request",
    "package_name": "Package Name",
    "function_module": "Function Module",
    "optional": "Optional"
  },
  "pca": {
    "pdmr_pca_list": "PDMR / PCA List",
    "pdmr_information": "PDMR Information",
    "pca_information": "PCA Information",
    "natural_person": "Natural person",
    "legal_person": "Legal person",
    "first_name": "First Name",
    "last_name": "Last Name",
    "name": "Name",
    "position_at_client": "Position at Client",
    "email_address": "Email Address",
    "phone_number": "Phone Number",
    "id_number": "ID Number",
    "place_of_birth": "Place of Birth",
    "date_of_birth": "Date of Birth",
    "time_of_inclusion": "Date of Inclusion",
    "modify": "Modify",
    "discard": "Discard",
    "save": "Save",
    "add_a_new_pca": "Add a New PCA",
    "download_all_notifications": "Download All Notifications",
    "pca_name": "PCA Name",
    "pca_email_address": "PCA Email Address",
    "reported_transactions": "Reported Transactions",
    "notify_new_transaction": "Notify New Transaction",
    "download_application": "Download Application",
    "periods_covered_by_the_trade_ban": "Periods Covered by The Trade Ban",
    "requests_on_trading_ban_exemption": "Requests on Trading Ban Exemption",
    "new_application": "New Application",
    "download": "Download",
    "insider_list": "Insider list",
    "market_sounding_data_room": "Market Sounding Data Room",
    "non_market_sounding_data_room": "Non-Market Sounding Data Room",
    "data_room_name": "Data Room Name",
    "transaction_details": "Transaction Details",
    "notification_date": "Notification Date",
    "request_id": "Request ID",
    "date": "Date",
    "approved_rejected": "Approved/Rejected",
    "request_sent": "Request Sent",
    "request_link": "Request Link",
    "function_and_reason_for_being_insider_placeholder": "Function and Reason",
    "new_transaction": "New Transactions",
    "restore": "Restore",
    "delete": "Delete"
  },
  "pdmr-list": {
    "pdmr_pca_list": "PDMR / PCA List",
    "notifications": "Notifications",
    "add_new": "Add New",
    "add_new_pdmr": "Add New PDMR",
    "add_new_pca": "Add New PCA",
    "position_at_client": "Position at Client",
    "phone_number": "Phone Number",
    "place_of_birth": "Place of Birth",
    "date_of_birth": "Date of Birth",
    "id_number": "ID Number",
    "date_of_inclusion": "Date of Inclusion",
    "registered_seat": "Registered Seat",
    "registration_number": "Registration Number",
    "download_list": "Download List",
    "pdmr_pca_data": "PDMR/PCA Data",
    "date_completeness": "Data Completeness",
    "notification_status": "Notification Status",
    "successful_modification": "Successful Modification",
    "successful_deletion": "Successful Deletion",
    "modify": "Modify",
    "save": "Save",
    "discard": "Discard",
    "delete": "Delete",
    "back": "Back",
    "first_name": "First Name",
    "last_name": "Last Name",
    "email_address": "Email Address",
    "sync_data": "Sync Data",
    "attention_data_is_not_up_to_date": "Attention! Data is not up to date.",
    "do_you_want_to_delete_this_pdmr_pca": "Do you want to delete this PDMR/PCA?",
    "related_pdmr": "Related PDMR",
    "please_choose": "Please Choose...",
    "default_select_example": "Default select example",
    "nature_of_the_relationship": "Nature of the relationship",
    "please_choose_a_pdmr": "Please choose a PDMR and a type of relation!",
    "next": "Next",
    "email": "Email",
    "subject": "Subject",
    "body": "Body",
    "inclusion_email_attachments": "Inclusion Email Attachments",
    "uploaded_files": "Uploaded Files",
    "upload_file": "Upload File",
    "send": "Send",
    "company_name": "Company Name",
    "companys_registration_number": "Company's Registration Number",
    "notify_pdrm": "Notify PDMR of his/her obligations under MAR.",
    "notify_pca": "Notify PCA of his/her obligations under MAR.",
    "entry_of_the_pca_in_the_register": "Entry of the PCA in the register",
    "pursuant_to_article_19_5": "Pursuant to Article 19(5), issuers shall notify the PDMRs of their obligations under MAR in writing. Are you sure you do not want to send this notification?",
    "decrypt_request": "Decrypt Request",
    "request_sent": "Request sent",
    "up_to_date": "Up to date",
    "loading": "Loading",
    "save_selected_representatives": "Save selected representatives",
    "items_per_page": "Items per page",
    "page": "Page",
    "board_member": "Board member",
    "representative": "representative",
    "name_of_the_person": "Name of the Person",
    "no_data_to_show": "No data to show",
    "download_all_notifications": "Download All Notification",
    "director": "Director",
    "new_pdmrs": "New PDMRS",
    "notification_emails": "Notification Emails",
    "download": "Download",
    "consent_statement": "Consent Statement",
    "are_you_sure_you_want_to_sync_data": "Attention, data synchronization is only possible for PDMRs, for PCAs, the data must always be entered manually.",
    "cancel": "Cancel",
    "no_decrypted_data": "Decryption is in progress. Please contact your investor relations representative if necessary.",
    "return_to_pdmr_list": "Return to PDMR List"
  },
  "pdmr": {
    "pdmr_pca_list": "PDMR / PCA List",
    "pdmr_information": "PDMR Information",
    "pca_information": "PCA Information",
    "name": "Name",
    "first_name": "First Name",
    "last_name": "Last Name",
    "position_at_client": "Position at Client",
    "email_address": "Email Address",
    "phone_number": "Phone Number",
    "id_number": "ID Number",
    "place_of_birth": "Place of Birth",
    "date_of_birth": "Date of Birth",
    "time_of_inclusion": "Date of Inclusion",
    "modify": "Modify",
    "discard": "Discard",
    "save": "Save",
    "add_a_new_pca": "Add a New PCA",
    "download_all_notifications": "Download All Notifications",
    "pca_name": "PCA Name",
    "pca_email_address": "PCA Email Address",
    "reported_transactions": "Reported Transactions",
    "notify_new_transaction": "Notify New Transaction",
    "download_application": "Download Application",
    "periods_covered_by_the_trade_ban": "Periods Covered by The Trade Ban",
    "requests_on_trading_ban_exemption": "Requests on Trading Ban Exemption",
    "new_application": "New Application",
    "download": "Download",
    "insider_list": "Insider list",
    "market_sounding_data_room": "Market Sounding Data Room",
    "non_market_sounding_data_room": "Non-Market Sounding Data Room",
    "data_room_name": "Data Room Name",
    "transaction_details": "Transaction Details",
    "notification_date": "Notification Date",
    "request_id": "Request ID",
    "date": "Date",
    "approved_rejected": "Approved/Rejected",
    "request_sent": "Request Sent",
    "request_link": "Request Link",
    "function_and_reason_for_being_insider_placeholder": "Function and Reason",
    "request_information": "Request Information",
    "status": "Status",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "approved_at": "Approved At",
    "rejected_at": "Rejected At",
    "approval_details": "Approval Details",
    "upload_file": "Upload file",
    "restore": "Restore",
    "delete": "Delete",
    "download_trade_ban_notifications": "Download Trade Ban Notifications",
    "return_to_pdmr_list": "Return to PDMR List"
  },
  "period-ban": {
    "fixing_the_period_covered_by_the_trading_ban": "Trading ban periods",
    "start_date_of_publication_of_half_yearly": "Publication date of half-yearly financial reports:",
    "date_of_publication_of_half_yearly": "Publication date of semi-annual financial reports:",
    "end_date_of_publication_of_half_yearly": "End date of publication of half-yearly financial reports:",
    "start_date_of_publication_of_annual": "Start date of publication of annual financial reports:",
    "date_of_publication_of_annual": "Publication date of annual financial reports:",
    "end_date_of_publication_of_annual": "End date of publication of annual financial reports:",
    "save": "Save",
    "send_emails_automatically": "Send emails automatically",
    "days_before_the_start_of_closed_period": "day(s) before the start of closed period.",
    "list_of_persons_to_be_notified": "List of persons to be notified",
    "date_sent": "Date Sent",
    "previous_notifications": "Previous Notifications",
    "requests_on_trade_ban_excemptions": "Requests on Trading Ban Exemption",
    "reject": "Reject",
    "accept": "Accept",
    "are_you_sure_you_want_to_accept_the_excemption": "Are you sure you want to accept the exemption?",
    "are_you_sure_you_want_to_reject_the_excemption": "Are you sure you want to reject the exemption?",
    "back": "Back",
    "pdmr_name": "PDMR Name",
    "email_address": "Email Address",
    "time_of_notification": "Time of Notification",
    "automatic_email_notifications": "Automatic Email Notifications",
    "name": "Name",
    "request_link": "Request Link",
    "dt_placeholder": "yyyy.mm.dd hh:mm",
    "successfully_updated_period": "Successfully updated period!",
    "ban_period_successfully_updated": "Ban period successfully updated!",
    "successfully_updated_notification_state": "Successfully updated notification state!",
    "successfully_accepted_excemption_request": "Successfully accepted exemption request!",
    "successfully_rejected_excemption_request": "Successfully rejected exemption request!",
    "there_is_no_notification": "There is no notification to show",
    "time_period_should_be_updated": "Time period should be updated",
    "download": "Download",
    "edit": "Edit",
    "cancel": "Cancel"
  },
  "privacy-policy": {
    "test": ""
  },
  "published-reports": {
    "unpublished_pdmr_pca_reports": "Unpublished PDMR / PCA reports",
    "search": "Search",
    "provide_publishing_information": "Provide Publishing Information",
    "published_pdmr_pca_reports": "Published PDMR / PCA reports",
    "published_link": "Published Link",
    "name_of_applicant": "Name of Applicant",
    "time_of_notification": "Date of Notification",
    "pdmr_pca": "PDMR / PCA",
    "view_form": "View Form",
    "dt_placeholder": "yyyy.mm.dd hh:mm",
    "published_report_template_title": "Template form for notification and public disclosure of transactions by persons discharging managerial responsibilities and persons closely associated with them, in accordance with Article 19 of Regulation (EU) No 596/2014 on market abuse (MAR)",
    "published_report_template_section1": "Details of the person discharging managerial responsibilities/person closely associated",
    "published_report_template_name": "Name",
    "published_report_template_section2": "Reason for the notification",
    "published_report_template_position": "Position/status",
    "published_report_template_notification": "Initial notification/Amendment",
    "published_report_template_section3": "Details of the issuer, emission allowance market participant, auction platform, auctioneer or auction monitor",
    "published_report_template_issuerName": "Name",
    "published_report_template_lei": "LEI",
    "published_report_template_section4": "Details of the transaction(s): section to be repeated for i) each type of instrument; ii) each type of transaction; iii) each date; and iv) each place where transactions have been conducted",
    "published_report_template_instrumentDescription": "Description of the financial instrument, type of instrument",
    "published_report_template_identificationCode": "Identification code",
    "published_report_template_transactionNature": "Nature of the transaction",
    "published_report_template_pricesVolumes": "Price(s) and volume(s)",
    "published_report_template_price": "Price(s)",
    "published_report_template_volume": "Volume(s)",
    "published_report_template_aggregatedInfo": "Aggregated information",
    "published_report_template_aggregatedVolume": "Aggregated volume",
    "published_report_template_transactionDate": "Date of the transaction",
    "published_report_template_transactionPlace": "Place of the transaction",
    "published_report_template_documentTitle": "MAR 19 - Management Transactions Notification",
    "initial_notification": "Initial Notification",
    "prior_notification": "Amendment to Prior Notifications"
  },
  "reset-password": {
    "reset_your_password": "Reset your password",
    "enter_your_registered_email_address": "Enter your registered E-mail & we will send to you a password reset link.",
    "new_password": "New password",
    "reset_password": "Reset password",
    "email_address": "Email Address",
    "enter_your_new_password": "Enter your new password",
    "confirm_password": "Confirm password",
    "repeat_password": "Repeat password",
    "dont_have_an_account": "Don't have an account?",
    "sign_up": "Sign up",
    "email_hone_number": "e-mail / phone number",
    "email_address_phone_number": "Email Address / Phone Number",
    "send_code": "Send Code",
    "didnt_receive_code_yet": "Didn't receive code yet?",
    "resend_link": "Resend link",
    "a_reset_link_has_been_sent_to_your_email_address": "A reset link has been sent to your email address."
  },
  "reset-sent": {
    "reset_your_password": "Reset your password",
    "didnt_receive_code_yet": "Didn't receive code yet?",
    "resend_link": "Resend link",
    "a_reset_link_has_been_sent_to_your_email_address": "A reset link has been sent to your email address."
  },
  "serviceprovider": {
    "test": ""
  },
  "settings": {
    "change_password": "Change Password",
    "old_password": "Old Password",
    "password": "Password",
    "confirm_password": "Confirm Password",
    "user_data": "User Data",
    "company_name": "Company name",
    "company_headquarters": "Company Headquarters",
    "automatically_log_off_users_after": "Automatically log off users after",
    "input": "Input",
    "minutes_of_inactivity": "minutes of inactivity.",
    "change_data": "Change Data",
    "client_decrypt_request": "Client Decrypt Request",
    "login_history": "Login history",
    "permanently_delete_profile": "Permanently Delete Profile",
    "delete_my_account": "Delete My Account",
    "site_documents": "Site documents",
    "document_title": "Document Title",
    "document_type": "Document Type",
    "document_content": "Document Content",
    "date": "Date",
    "edit_document": "Edit document",
    "from_date": "From Date",
    "document_title_required": "Document title is required",
    "from_date_required": "From date is required",
    "document_content_required": "Document content is required",
    "create_document": "Create document",
    "delete_document": "Delete document",
    "name": "Name of Contact Person",
    "position": "Position of Contact Person",
    "email": "Email of Contact Person",
    "phone_number": "Phone Number of Contact Person",
    "company_registration_number": "Company Registration Number",
    "headquarters": "Company Address",
    "tax_number": "Tax Number",
    "lei_number": "LEI Number",
    "data_protection_officer": "Data Protection Officer",
    "client_name": "Client Name",
    "edit_privacy_policy": "Edit Privacy Policy",
    "save": "Save",
    "cancel": "Cancel",
    "increase_login_time": "Increase login time",
    "passwordless_login_toggle": "Passwordless login",
    "unsecure_login_toggle": "Unsecure login",
    "unsecure_login_warning_title": "Attention!",
    "unsecure_login_confirm_enable": "By enabling this feature, private keys will be sent via email to lower privileges (list users, PDMR, PCA). This feature is less secure, but allows for faster login.",
    "unsecure_login_confirm_disable": "By disabling this feature, previously sent private keys via email will still be valid. If necessary, delete them after disabling this feature.",
    "address": "Address",
    "contact_person_address": "Contact person address",
    "pdmr_name": "PDMR name",
    "pca_name": "PCA name",
    "insider_list_user_name": "Name",
    "advisory_list_user_name": "Name",
    "data_room_user_name": "Data room user name",
    "pdmr_email": "PDMR email",
    "pca_email": "PCA email",
    "insider_list_user_email": "Email address",
    "advisory_list_user_email": "Email address",
    "data_room_user_email": "Data room user email",
    "pdmr_position": "PDMR position",
    "pca_position": "PCA position",
    "insider_list_user_position": "Position",
    "advisory_list_user_position": "Position",
    "data_room_user_position": "Data room user position",
    "pdmr_phone_number": "PDMR phone number",
    "pca_phone_number": "PCA phone number",
    "insider_list_user_phone_number": "Phone number",
    "advisory_list_user_phone_number": "Phone number",
    "data_room_user_phone_number": "Data room user phone number",
    "pdmr_address": "PDMR address",
    "pca_address": "PCA address",
    "insider_list_user_address": "Address",
    "advisory_list_user_address": "Address",
    "data_room_user_address": "Data room user address"
  },
  "sidebar": {
    "classification_and_delay_of_inside_info": "Inside Information",
    "insider_list": {
      "title": "Insider List",
      "submenu": {
        "permanent_insider_list": "Permanent Insider List",
        "transaction-specific_insiders_list": "Transaction-Specific Insiders List",
        "confidential_list": "Confidential List"
      }
    },
    "management_transactions": {
      "title": "Management Transactions",
      "submenu": {
        "record-keeping": "Record-keeping",
        "transaction_reporting_for_executives_and_close_associates": "Transaction reporting for executives and close associates",
        "trading_ban_period": "Trading Ban Period"
      }
    },
    "transfer_of_inside_info": "Data room",
    "transaction_form": "Transaction form",
    "dashboard": "Dashboard",
    "advisory_list": "Advisory list",
    "statements": "Statements",
    "advisory": {
      "title": "Advisory",
      "submenu": {
        "companies": "Companies",
        "advisory_insider_lists": "Advisory Insider Lists"
      }
    }
  },
  "signup": {
    "signup_to_mabureg": "Signup to MABUREG",
    "welcome_aboard_lets_begin": "Welcome aboard, Let’s begin.",
    "investor_contacts_email": "Investor Contact's email",
    "investor_contacts_password": "Investor Contact's password",
    "clients_name": "Client's name",
    "clients_address": "Client's address",
    "investor_contacts_name": "Investor Contact's Name",
    "investor_contacts_position": "Investor Contact's Position",
    "investor_contacts_phone_number": "Investor Contact's Phone Number",
    "company_registration_number": "Company Registration Number",
    "tax_number": "Tax Number",
    "lei_number": "LEI Number",
    "delegate_access_to_other_people": "Delegate access to other people",
    "add_decision_maker": "Add Decision Maker",
    "next": "Next"
  },
  "site-document-create": {
    "document_title": "Document Title",
    "document_type": "Document Type",
    "document_content": "Document Content",
    "date": "Date",
    "create_document": "Create document",
    "from_date": "From Date",
    "document_title_required": "Document title is required",
    "from_date_required": "From date is required",
    "document_content_required": "Document content is required",
    "save": "Save",
    "cancel": "Cancel",
    "privacy_policy": "Privacy Policy",
    "terms_and_conditions": "Terms and Conditions"
  },
  "site-document-edit": {
    "document_title": "Document Title",
    "document_type": "Document Type",
    "document_content": "Document Content",
    "date": "Date",
    "edit_document": "Edit document",
    "from_date": "From Date",
    "document_title_required": "Document title is required",
    "from_date_required": "From date is required",
    "document_content_required": "Document content is required",
    "save": "Save",
    "cancel": "Cancel",
    "privacy_policy": "Privacy Policy",
    "terms_and_conditions": "Terms and Conditions"
  },
  "site-documents": {
    "site_documents": "Site documents",
    "create_document": "Create document",
    "edit": "Edit",
    "delete": "Delete",
    "delete_document": "Delete document",
    "cancel": "Cancel",
    "document_title": "Document title",
    "document_type": "Document type",
    "date": "Date"
  },
  "specific-insider-details": {
    "short_name_of_insider_information": "Short Name of Insider Information",
    "date_placeholder": "DD/MM/YYYY",
    "dt_of_creation_of_permanent_insider_section": "Date & Time of creation of the permanent insiders section",
    "dt_of_last_update": "Date & Time of the last update",
    "date_of_transmission_to_competent_authority": "Date of transmission to the competent authority",
    "project_name": "Project Name",
    "inside_information": "Inside Information",
    "add_new_person": "Add New Person",
    "export_insider_list": "Export Insider List",
    "delete": "Delete",
    "first_name": "First Name",
    "surname": "Surname",
    "birth_surname": "Birth Surname",
    "professional_telephone_number": "Professional Telephone Number",
    "companys_name": "Company's Name",
    "companys_address": "Company's Address",
    "function_and_reason_for_being_insider": "Function and reason for being insider",
    "function_and_reason_for_being_insider_title": "Text describing the role, function and reason for inclusion in this list",
    "function_and_reason_for_being_insider_title_reform": "Text describing role, function and reason for being on this list, including the company name and address in the case of third-party service providers.",
    "function_and_reason_for_being_insider_placeholder": "Function and Reason",
    "first_name_tooltip": "In the case of third-party service providers, the first name(s) of the natural person acting as a contact person for that third-party service provider.",
    "surname_tooltip": "In the case of third-party service providers, the surname(s) of the natural person acting as a contact person for that third-party service provider.",
    "included": "Included",
    "obtained": "Obtained",
    "ceased": "Ceased",
    "birthdate": "Date of Birth",
    "national_id_card_number": "National Identification Number",
    "personal_telephone_number": "Personal Telephone Number",
    "personal_full_home_address": "Personal Full Home Address",
    "personal_full_home_address_title": "Country, postcode, city, street, house number",
    "discard": "Discard",
    "save_data": "Save",
    "this_insider_information_was_disclosed": "This inside information was disclosed in the course of market sounding.",
    "sending_the_notice_is_a_legal_obligation": "Sending the notice is a legal obligation. Are you sure you do not want to send the notification?",
    "name_of_the_insider": "Name of the Insider",
    "data_completeness": "Data Completeness",
    "last_login": "Last Login",
    "do_you_want_to_delete_this_insider": "Do you want to delete this insider?",
    "back": "Back",
    "modify": "Modify",
    "deal_specific_insider_list": "Deal-Specific Insider List",
    "insider_list": "Insider list",
    "notifications_and_acknowledgements": "Notifications and Acknowledgments",
    "mar_18_notifications": "MAR 18(2) Notifications",
    "mar_18_acknowledgements": "MAR 18(2) Acknowledgements",
    "resend_notification": "Resend notification email",
    "download_all_acknowledgements": "Download All Acknowledgements",
    "download_all_notification_emails": "Download All Notification Emails",
    "name_of_insider": "Name of Insider",
    "email_address": "Email Address",
    "date_and_time_of_creation": "Date and Time of Creation",
    "export": "Export",
    "market_sounding_data_room": "Market Sounding Data Rooms",
    "non_market_sounding_data_room": "Non-Market Sounding Data Room",
    "not_logged_in_yet": "Not logged in yet",
    "insider_lists": "Insider lists",
    "select_version": "Choose version...",
    "dt_of_persons_inclusion": "The date and time at which the insider obtained access to the inside information.",
    "dt_of_persons_inclusion_reform": "The date and time when the insider obtained access to the specific piece of inside information.",
    "my_personal_data": "My personal data",
    "company_name": "Company Name",
    "company_address": "Company Address",
    "permanent_insider_list": "Permanent Insider List",
    "edit": "Edit",
    "disable": "Disable",
    "download": "Download",
    "statements": "Statements",
    "date_sent": "Date Sent",
    "notification_emails": "Notification Email(s)",
    "accepted_at": "Accepted At",
    "national_id_card_number_tooltip": "National ID card / passport number.",
    "national_id_card_number_tooltip_reform": "ID card or passport number.",
    "permanently_delete": "Permanently Delete",
    "delete_date": "Delete Date",
    "blocked_at_tooltip": "The date and time at which the insider ceased to have access to the inside information.",
    "blocked_at_tooltip_reform": "The date and time when the insider ceased to have access to the specific piece of inside information.",
    "confidential_list": "Sensitive List Members",
    "normal_list": "Normal List Members",
    "name_of_the_list": "Name of the List",
    "name_of_the_normal_list": "Name of the List",
    "confidential_insider_list": "Confidential Insider List",
    "normal_insider_list": "Normal Insider List",
    "this_list_is_old": "This list is old and cannot be edited.",
    "no_decrypted_data": "Decryption is in progress. Please contact your investor relations representative if necessary.",
    "no_statement_file": "No statement file",
    "statements_text": "Statement of acknowledgement",
    "notifications": "Notifications",
    "function_and_reason_for_being_insider_confidential": "Function and reason for being included",
    "function_and_reason_for_being_insider_title_confidential": "Function and reason for being included",
    "function_and_reason_for_being_insider_title_confidential_reform": "Text describing role, function and reason for being on this list, including the company name and address in the case of third-party service providers.",
    "dt_of_persons_inclusion_confidential": "Date and time when you obtained access to the information",
    "dt_of_persons_inclusion_confidential_reform": "The date and time when the person obtained access to the specific piece of information.",
    "function_and_reason_for_being_insider_title_permanent_reform": "Text describing role, function and reason for being in this section, including the company name and address in the case of third-party service providers.",
    "function_and_reason_for_being_insider_title_sme_reform": "Text describing role, function and reason for being in this list, including the company name and address in the case of third-party service providers.",
    "dt_of_persons_inclusion_permanent_reform": "The date and time when the insider obtained access to all inside information at all times.",
    "dt_of_persons_inclusion_sme_reform": "The date and time when the insider obtained regular access to inside information.",
    "name_of_the_confidential_list": "Confidential List"
  },
  "specific-insiders": {
    "closed_insider_lists": "Closed insider lists",
    "current_insider_lists": "Current insider lists",
    "search": "Search",
    "download": "Download",
    "details": "Details",
    "inside_information": "Inside Information",
    "project_name": "Project Name",
    "time_of_creation": "Time of Creation",
    "number_of_persons_included": "Persons Included",
    "date_of_closure": "Date of Closure",
    "short_name_of_insider_information": "Short Name of Insider Information",
    "dt_placeholder": "dd-mm-yyyy; hh:mm",
    "number_of_people": "Number of People",
    "insider_lists": "Insider lists",
    "edit": "Edit",
    "create_missing_deal_specific_insider_list": "Create Missing Deal Specific Insider List"
  },
  "statements": {
    "statements": "Statements",
    "description": "The declarations must be submitted at the request of the MNB, so the system stores them in a separate file (in the wireframe, these are the so-called declarations of recognition).",
    "dataroom": "Dataroom user to a market sounding data room",
    "dataroom_contains_insider_info": "In case the data room contains inside info",
    "dataroom_insider_info_statement_1": "I acknowledge that the documents and information shared in the data room will be disclosed in the context of market sounding under Article 11 of Regulation (EU) No 596/2014 on market abuse.",
    "dataroom_insider_info_statement_2": "I confirm that {clientName} is communicating with the person entrusted by the potential investor to receive the market sounding.",
    "dataroom_insider_info_statement_3": "I acknowledge that if I agree to receive the market sounding, I will receive information that {clientName} considers to be inside information. I acknowledge that, in each case, I must judge for myself whether I am in possession of inside information and at what point in time the information in my possession ceases to be inside information.",
    "dataroom_insider_info_statement_4": "I understand that if the inside information provided ceases to be inside information, I will be informed of this fact by e-mail.",
    "dataroom_insider_info_statement_5": "I acknowledge that I am prohibited from using the inside information provided, or attempting to use that information, by acquiring or disposing of, for my own account or for the account of a third party, directly or indirectly, financial instruments relating to that information.",
    "dataroom_insider_info_statement_6": "I acknowledge that I am prohibited from using the inside information provided, or attempting to use that information, by cancelling or amending an order which has already been placed concerning a financial instrument to which the information relates.",
    "dataroom_insider_info_statement_7": "I understand that by agreeing to receive inside information I am obliged to keep the inside information confidential.",
    "dataroom_insider_info_statement_8": "I expressly consent to receive inside information in the course of market sounding.",
    "dataroom_insider_info_statement_9": "I acknowledge that the data room contains all information provided for the purpose of market sounding, separately identifying the information that is considered by {clientName} to be inside information.",
    "i_have_read_and_understood": "I have read the privacy notice and I accept the <a href=\"https://mabureg.com/privacy-policy\" target=\"_black\">privacy policy.</a>",
    "i_have_read_and_understood_no_link": "I have read the privacy notice and I accept the privacy policy.",
    "dataroom_does_not_contain_insider_info": "In case there is no inside info",
    "dataroom_no_insider_info_statement_1": "I acknowledge that the documents and information shared in the data room will be disclosed in the context of market sounding under Article 11 of Regulation (EU) No 596/2014 on market abuse.",
    "dataroom_no_insider_info_statement_2": "I confirm that {clientName} is communicating with the person entrusted by the potential investor to receive the market sounding.",
    "dataroom_no_insider_info_statement_3": "I acknowledge that if I agree to receive the market sounding, I will receive information that {clientName} considers not to be inside information. I acknowledge that, in each case, I must judge for myself whether I am in possession of inside information and at what point in time the information in my possession ceases to be inside information.",
    "dataroom_no_insider_info_statement_4": "I expressly consent to information being provided to me in the course of market sounding.",
    "dataroom_no_insider_info_statement_5": "I acknowledge that the data room contains all information provided for the purpose of market sounding.",
    "dataroom_classic_statement_1": "I expressly acknowledge that I have been informed by {clientName} of the legal and regulatory duties entailed with inclusion on the insider list and of the sanctions applicable to insider dealing and unlawful disclosure of inside information.",
    "dataroom_classic_statement_2": "I acknowledge that {clientName} is obliged to retain the insider list for at least five years after it is drawn up or updated and to submit it to the Hungarian National Bank as soon as possible upon request.",
    "insider_first_login": "Insider",
    "insider_first_login_statement_1": "I expressly acknowledge that I have been informed by {clientName} of the legal and regulatory duties entailed with inclusion on the insider list and of the sanctions applicable to insider dealing and unlawful disclosure of inside information.",
    "insider_first_login_statement_2": "I acknowledge that {clientName} is obliged to retain the insider list for at least five years after it is drawn up or updated and to submit it to the Hungarian National Bank as soon as possible upon request.",
    "draw_signature": "Draw Signature",
    "sign": "Sign",
    "cancel": "Cancel",
    "clear": "Clear",
    "signature": "Signature",
    "you_must_accept_all_the_statements": "You must accept all the statements before using the platform.",
    "insider_list": "Insider List",
    "advisory_insider_list": "Advisory insider list",
    "insider_list_confidential": "Confidential List",
    "data_room": "Data Room",
    "name": "Name",
    "status": "Status",
    "permanent_insider_list": "Permanent insider list",
    "name_of_person": "Name of the person making the statement",
    "date_of_disclosure": "Date and time of disclosure",
    "proceed_to_using_mabureg": "Proceed to using Mabureg",
    "transaction_specific_insider_list": "Transaction-specific insider list",
    "privacy_policy": "Privacy Policy",
    "i_accept_the_privacy_policy": "I accept the privacy policy",
    "signature_required": "Signature is required",
    "statement": "Statement",
    "insider_list_statement": "about inclusion in the insider list",
    "market_sounding_statement": "in connection with market sounding",
    "classic_statement": "in connection with non market sounding",
    "this_insider_information_was_disclosed": "This inside information was disclosed in the course of market sounding.",
    "compliance_statements_title": "Statements (current wording)",
    "compliance_statements_hint": "Sign using the wording defined by your organisation. Use the list below if you need the latest version.",
    "compliance_statement_load_error": "Could not load this statement. Please go back and try again."
  },
  "subscriptions": {
    "subscribed_package": "Subscribed Package",
    "subscribed_package_name": "Subscribed Package Name",
    "download_content": "Download Content",
    "change_subscription": "Change Subscription",
    "my_accounts": "My Accounts",
    "seach_accounts_by_number": "Search accounts by Number",
    "account_number": "Account Number",
    "date_of_issue": "Date of Issue",
    "date_of_completion": "Date of Completion",
    "download_request": "Download Request",
    "download_invoice": "Download Invoice",
    "packages": "Packages",
    "sme": "SME",
    "essential": "Essential",
    "complete": "Complete",
    "for_issuers_listed_on_sme_growth_markets": "For issuers listed on SME Growth Markets",
    "documenting_the_decision_on_the_qualification_of_inside_information": "Documenting the decision on the qualification of inside information",
    "documenting_the_decision_on_delaying_the_disclosure_of_inside_information": "Documenting the decision on delaying the disclosure of inside information",
    "creation_and_automated_management_of_sme_insider_list": "Creation and automated management of “SME insider list”",
    "creation_of_confidential_lists_and_conversion_into_insider_lists": "Creation of confidential lists and conversion into insider lists",
    "creation_and_automated_management_of_pdmr_pca_list": "Creation and automated management of PDMR / PCA list",
    "pdmr_pca_transaction_notifications_automatic_notifications_on_closed_periods": "PDMR / PCA transaction notifications, automatic notifications on closed periods",
    "transfer_of_inside_information_through_high_security_data_rooms_with_automatic_insider_listing": "Transfer of inside information through high-security data rooms with automatic insider listing",
    "transfer_of_inside_information_in_the_course_of_market_soundings_via_data_rooms": "Transfer of inside information in the course of market soundings via data rooms",
    "integration_with_the_local_competent_authorities_it_systems": "Integration with the local competent authorities’ IT systems",
    "regulated_market": "Regulated Market",
    "for_issuers_listed_on_eu_regulated_markets": "For issuers listed on EU Regulated Markets",
    "creation_and_automated_management_of_the_permanent_section_of_the_insider_list": "Creation and automated management of the permanent section of the insider list",
    "creation_and_automated_management_of_the_deal_specific_section_of_the_insider_list": "Creation and automated management of the deal-specific section of the insider list",
    "8_years": "8/year",
    "unlimited": "Unlimited",
    "request_an_offer": "Request an offer"
  },
  "terms-and-conditions": {
    "test": ""
  },
  "terms": {
    "please_read_the_terms_carefully": "Please read the terms carefully",
    "please_provide_us_with_the_following": "Please provide us with the following data",
    "phone_number": "Phone Number",
    "address": "Address",
    "go_to_the_data_room": "Go To The Data Room"
  },
  "thank-you": {
    "thank_you": "Thank you!",
    "i_agree_to_privacy_policy": "I agree to Privacy Policy { link }",
    "back": "Back",
    "next": "Next"
  },
  "unauthorized": {
    "unauthorized": "Unauthorized",
    "it_seems_like_you_dont_have_access": "It seems like you don't have access to this page",
    "go_back": "Go back",
    "report": "Report"
  },
  "upload-application": {
    "upload_application": "Upload Application",
    "file_name": "File Name",
    "proceed": "Proceed"
  },
  "users": {
    "users": "Users",
    "full_name": "Full Name",
    "email": "Email",
    "id_number": "ID Number",
    "last_login": "Last Login",
    "privacy_statement": "Privacy Statement",
    "actions": "Actions",
    "remove_master_key": "Remove Master Key",
    "are_you_sure_you_want_to_delete_this_users_master_key": "Are you sure you want to delete this user's master key?",
    "delete_master_key": "Delete Master Key",
    "regenerate_master_key": "Regenerate master key",
    "are_you_sure_you_want_to_regenerate_this_users_master_key": "Are you sure you want to regenerate this user's master key? They will receive the new master password by email.",
    "regenerate_master_key_missing_password": "Enter your master password to continue.",
    "regenerate_master_key_missing_email": "This user has no email address; the new master password cannot be sent.",
    "cancel": "Cancel",
    "fullname": "Full Name",
    "id": "ID",
    "download": "Download",
    "delete": "Delete",
    "permanent_delete": "Permanent Delete",
    "permanent_delete_description": "I am permanently and irrevocably deleting the following user:",
    "permanent_delete_sub_description": "To confirm, copy the customer's name into the input field",
    "discard": "Discard",
    "permanent_delete_error_message": "The name you entered does not match the user's name",
    "permanent_delete_success_message": "User permanently deleted"
  },
  "verify-code": {
    "login_to_mabureg": "Login to MABUREG",
    "a_verification_code_has_been_sent": "A verification code has been sent to your email / phone. This code is valid for 10 minutes.",
    "code": "Code",
    "verify_login": "Verify & Login"
  }
}